/* ================= REGULATION ================= */
function initRegulation() {
    /* RO: Regulamentul implicit al unui club NOU. Se generează prin `t()`, deci
           apare în limba celui care îl vede, atât timp cât niciun admin nu l-a
           editat încă (`initRegulation` rulează la hidratare când clubul n-are
           regulament salvat în `club_settings`). Din momentul primei editări,
           textul se îngheață în limba de atunci — comportament normal: de acolo
           încolo e textul clubului, nu al aplicației.

           Cele cinci articole vechi (propunere, selecție, GM, restricții, termen)
           erau specifice unui singur mod de funcționare și se citeau ca un
           regulament deja scris de altcineva. Acum sunt comprimate în Art. 1, ca
           puncte, iar restul acoperă lucrurile de care are nevoie ORICE club —
           de la unul de prieteni la unul de competiție — și pe care fiecare le
           poate rescrie.
       EN: default club regulation, generated through i18n so it appears in the
           reader's language until an admin edits it. */
    if (state.regulation.articles.length === 0) {
        const acum = new Date().toISOString();
        const art = (n) => ({
            id: n,
            version: "1.0",
            title: t('regdef.a' + n + '.title'),
            content: t('regdef.a' + n + '.body'),
            effectiveDate: acum,
            amendments: []
        });
        state.regulation.articles = [art(1), art(2), art(3), art(4), art(5)];
        saveState();
    }
}

/* ================= CAMPANII / LEGACY (plan Pro+) ================= */
async function persistCampaigns() {
    if (isDemoMode() || !sb) return;
    try {
        await sb.from('club_settings').upsert(
            { club_id: currentClubId, key: 'campaigns', value: state.campaigns || [], updated_at: new Date().toISOString() },
            { onConflict: 'club_id,key' });
    } catch (e) { console.warn('persistCampaigns:', e && e.message); }
}

function campaignRecord(c) {
    const sc = c.scenarios || [];
    const wins = sc.filter(s => s.outcome === 'win').length;
    const losses = sc.filter(s => s.outcome === 'loss').length;
    return { total: sc.length, wins, losses };
}

function renderCampaigns() {
    const box = document.getElementById('campaignsList'); if (!box) return;
    const btn = document.getElementById('newCampaignBtn');
    if (!planAllows('campaigns')) { box.innerHTML = featureLockNote('campaigns'); if (btn) btn.style.display = 'none'; return; }
    if (btn) btn.style.display = '';
    const list = state.campaigns || [];
    if (!list.length) { box.innerHTML = `<p style="opacity:0.7;">${t('camp.noCampaigns')}</p>`; return; }
    const statusLabel = { active: t('camp.inProgress'), completed: t('camp.completedF'), abandoned: t('camp.abandoned') };
    const statusColor = { active: 'var(--accent-primary,#ff6b35)', completed: 'var(--success,#27ae60)', abandoned: '#888' };
    box.innerHTML = list.map(c => {
        const rec = campaignRecord(c);
        const scenarios = (c.scenarios || []).slice().sort((a, b) => new Date(a.date) - new Date(b.date));
        return `<div class="card" style="margin-bottom:14px; border-left:4px solid ${statusColor[c.status] || 'var(--accent-primary)'};">
            <div style="display:flex; justify-content:space-between; align-items:flex-start; gap:10px; flex-wrap:wrap;">
                <div style="min-width:0;">
                    <h3 style="margin:0;">${clubEsc(c.name)}</h3>
                    <div style="font-size:0.82em; opacity:0.75;">${c.game ? '🎲 ' + clubEsc(c.game) + ' • ' : ''}<span style="color:${statusColor[c.status] || ''};">${statusLabel[c.status] || t('camp.inProgress')}</span></div>
                </div>
                <div style="text-align:right; font-size:0.82em; opacity:0.85;">
                    ${rec.total} ${t('camp.scenarios')} • ${rec.wins}${t('camp.winShort')} / ${rec.losses}${t('camp.lossShort')}
                </div>
            </div>
            ${(c.roster && c.roster.length) ? `<div style="font-size:0.8em; opacity:0.75; margin-top:6px;"><i class="fas fa-users"></i> ${c.roster.map(r => clubEsc(r)).join(', ')}</div>` : ''}
            ${c.notes ? `<div style="font-size:0.85em; opacity:0.85; margin-top:6px; font-style:italic; overflow-wrap:anywhere; word-break:break-word; white-space:pre-wrap;">${clubEsc(c.notes)}</div>` : ''}
            ${scenarios.length ? `<div style="margin-top:10px;">${scenarios.map(s => {
                const oc = s.outcome === 'win' ? '✅' : s.outcome === 'loss' ? '❌' : '▫️';
                const d = s.date ? new Date(s.date).toLocaleDateString('en-GB') : '';
                return `<div style="display:flex; justify-content:space-between; align-items:flex-start; gap:8px; padding:6px 8px; background:var(--bg-primary); border-radius:8px; margin-bottom:4px;">
                    <span style="min-width:0; overflow-wrap:anywhere; word-break:break-word;">${oc} ${clubEsc(s.name)}${s.notes ? ` <span style="opacity:0.6; font-size:0.85em;">— ${clubEsc(s.notes)}</span>` : ''}</span>
                    <span style="display:flex; align-items:center; gap:8px; white-space:nowrap; flex:none;"><small style="opacity:0.6;">${d}</small><a href="javascript:void(0)" onclick="deleteCampaignScenario('${c.id}','${s.id}')" style="color:#e07a5f;"><i class="fas fa-times"></i></a></span>
                </div>`;
            }).join('')}</div>` : '<p style="opacity:0.6; font-size:0.85em; margin-top:8px;">' + t('camp.noScenarios') + '</p>'}
            <div class="btn-group" style="margin-top:10px;">
                <button class="btn btn-sm" onclick="addCampaignScenario('${c.id}')"><i class="fas fa-plus"></i> ${t('camp.scenario')}</button>
                <button class="btn btn-sm btn-secondary" onclick="openCampaignEditor('${c.id}')"><i class="fas fa-edit"></i> ${t('history.edit')}</button>
                <button class="btn btn-sm btn-danger" onclick="deleteCampaign('${c.id}')"><i class="fas fa-trash"></i></button>
            </div>
        </div>`;
    }).join('');
}

function openCampaignEditor(id) {
    if (!requireFeature('campaigns')) return;
    const c = id ? (state.campaigns || []).find(x => x.id === id) : null;
    const games = Object.keys(state.catalog || {}).sort();
    const members = Object.keys(state.members || {}).sort();
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.dataset.campaignId = id || '';
    modal.innerHTML = `<div class="modal-content"><div class="modal-header">
        <h2><i class="fas fa-scroll"></i> ${c ? t('camp.editTitle') : t('camp.newTitle')}</h2>
        <button class="modal-close" onclick="this.parentElement.parentElement.parentElement.remove()">×</button></div>
        <div class="form-group"><label for="campName">${t('camp.nameLabel')}</label><input type="text" id="campName" class="form-control" value="${c ? clubEsc(c.name) : ''}" placeholder="${t('camp.namePh')}"></div>
        <div class="form-group"><label for="campGame">${t('common.game')}</label>
            <input type="text" id="campGame" class="form-control" list="campGameList" value="${c ? clubEsc(c.game || '') : ''}" placeholder="Ex: Gloomhaven">
            <datalist id="campGameList">${games.map(g => `<option value="${clubEsc(g)}">`).join('')}</datalist>
        </div>
        <div class="form-group"><label for="campStatus">Stare</label>
            <select id="campStatus" class="form-control">
                <option value="active" ${(!c || c.status === 'active') ? 'selected' : ''}>${t('camp.inProgress')}</option>
                <option value="completed" ${c && c.status === 'completed' ? 'selected' : ''}>${t('camp.statusCompleted')}</option>
                <option value="abandoned" ${c && c.status === 'abandoned' ? 'selected' : ''}>${t('camp.statusAbandoned')}</option>
            </select>
        </div>
        <div class="form-group"><span class="form-section-label">${t('camp.roster')}</span>
            <div style="max-height:160px; overflow:auto; border:1px solid var(--border,#333); border-radius:8px; padding:8px;">
                ${members.length ? members.map(m => `<label style="display:flex; align-items:center; gap:8px; font-weight:normal; padding:2px 0;"><input type="checkbox" class="camp-roster" value="${clubEsc(m)}" ${c && (c.roster || []).indexOf(m) !== -1 ? 'checked' : ''}> ${clubEsc(m)}</label>`).join('') : '<small style="opacity:0.6;">Niciun membru.</small>'}
            </div>
        </div>
        <div class="form-group"><label for="campNotes">${t('common.notes')}</label><textarea id="campNotes" class="form-control" rows="2" placeholder="${t('camp.notesPh')}">${c ? clubEsc(c.notes || '') : ''}</textarea></div>
        <button class="btn btn-primary" onclick="saveCampaign()"><i class="fas fa-save"></i> ${t('common.save')}</button>
        </div>`;
    document.body.appendChild(modal);
}

async function saveCampaign() {
    const modal = document.querySelector('.modal.active[data-campaign-id]');
    if (!modal) return;
    const id = modal.dataset.campaignId;
    const isNewCamp = !id;
    const name = (document.getElementById('campName').value || '').trim();
    if (!name) { showNotification(t('m3.nameCampaign'), 'error'); return; }
    const game = (document.getElementById('campGame').value || '').trim();
    const status = document.getElementById('campStatus').value;
    const notes = (document.getElementById('campNotes').value || '').trim();
    const roster = Array.from(modal.querySelectorAll('.camp-roster:checked')).map(i => i.value);
    state.campaigns = state.campaigns || [];
    if (id) {
        const c = state.campaigns.find(x => x.id === id);
        if (c) { c.name = name; c.game = game; c.status = status; c.notes = notes; c.roster = roster; }
    } else {
        state.campaigns.push({
            id: 'camp-' + Date.now() + '-' + Math.random().toString(36).slice(2, 6),
            name, game, status, notes, roster, scenarios: [],
            createdBy: state.currentUser ? state.currentUser.name : '', createdAt: new Date().toISOString()
        });
    }
    modal.remove();
    await persistCampaigns();
    renderCampaigns(); updateTabBadges();
    if (isNewCamp) {
        try {
            if (typeof window.pushNotification === 'function' && typeof window.clubMemberIds === 'function') {
                const others = window.clubMemberIds(state.currentUser && state.currentUser.name);
                if (others.length) window.pushNotification(others, { type: 'campaign', icon: 'fa-dragon', tab: 'campaigns', text: window.t('notif.campaignNew').replace('{name}', name) });
            }
        } catch (e) { logError('saveCampaign', e); }
    }
    showNotification(t('m3.campaignSaved'), 'success');
}

function addCampaignScenario(campaignId) {
    if (!requireFeature('campaigns')) return;
    const c = (state.campaigns || []).find(x => x.id === campaignId); if (!c) return;
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.dataset.scenarioFor = campaignId;
    modal.innerHTML = `<div class="modal-content"><div class="modal-header">
        <h2><i class="fas fa-flag"></i> Scenariu — ${clubEsc(c.name)}</h2>
        <button class="modal-close" onclick="this.parentElement.parentElement.parentElement.remove()">×</button></div>
        <div class="form-group"><label for="scName">${t('camp.scNameLabel')}</label><input type="text" id="scName" class="form-control" placeholder="${t('camp.scNamePh')}"></div>
        <div class="form-row">
            <div class="form-group"><label for="scDate">${t('common.date')}</label><input type="date" id="scDate" class="form-control" value="${new Date().toISOString().split('T')[0]}"></div>
            <div class="form-group"><label for="scOutcome">${t('camp.outcome')}</label><select id="scOutcome" class="form-control"><option value="win">${t('camp.win')}</option><option value="loss">${t('camp.loss')}</option><option value="other">${t('camp.outcomeOther')}</option></select></div>
        </div>
        <div class="form-group"><label for="scNotes">${t('common.notes')}</label><textarea id="scNotes" class="form-control" rows="2" placeholder="${t('camp.scNotesPh')}"></textarea></div>
        <button class="btn btn-primary" onclick="saveCampaignScenario()"><i class="fas fa-save"></i> ${t('session.add')}</button>
        </div>`;
    document.body.appendChild(modal);
}

async function saveCampaignScenario() {
    const modal = document.querySelector('.modal.active[data-scenario-for]');
    if (!modal) return;
    const c = (state.campaigns || []).find(x => x.id === modal.dataset.scenarioFor); if (!c) return;
    const name = (document.getElementById('scName').value || '').trim();
    if (!name) { showNotification(t('m3.nameScenario'), 'error'); return; }
    c.scenarios = c.scenarios || [];
    c.scenarios.push({
        id: 'sc-' + Date.now() + '-' + Math.random().toString(36).slice(2, 6),
        name, date: document.getElementById('scDate').value || new Date().toISOString().split('T')[0],
        outcome: document.getElementById('scOutcome').value, notes: (document.getElementById('scNotes').value || '').trim()
    });
    modal.remove();
    await persistCampaigns();
    renderCampaigns();
    showNotification(t('m3.scenarioAdded'), 'success');
}

async function deleteCampaignScenario(campaignId, scenarioId) {
    const c = (state.campaigns || []).find(x => x.id === campaignId); if (!c) return;
    if (!await confirmModal(t('m3.confirmDeleteScenario'), { danger: true })) return;
    c.scenarios = (c.scenarios || []).filter(s => s.id !== scenarioId);
    await persistCampaigns();
    renderCampaigns();
}

async function deleteCampaign(id) {
    const c = (state.campaigns || []).find(x => x.id === id); if (!c) return;
    if (!await confirmModal(t('m3.confirmDeleteCampaign').replace('{name}', c.name), { danger: true })) return;
    state.campaigns = (state.campaigns || []).filter(x => x.id !== id);
    await persistCampaigns();
    renderCampaigns(); updateTabBadges();
    showNotification(t('m3.campaignDeleted'), 'info');
}

/* R1 (31 oct. 2026): REGULAMENTUL (salvarea, afișarea, ordinea, ștergerea, istoricul, partajarea,
   căutarea, delegarea acțiunilor, tipărirea, PDF-ul, fereastra de editare) a fost MUTAT identic în
   regulation.js. Aici rămân `initRegulation` (regulamentul implicit, chemat la hidratare) și `_pdfSafe`
   (îl folosește și exportul PDF al istoricului). EN: regulation moved to regulation.js. */

/* Fonturile standard jsPDF (WinAnsi) NU au glifele românești cu virgulă
   (ă â î ș ț) — apar litere „sparte" și metrici greșite (depășiri de margine).
   Fără un TTF Unicode înglobat (fonturile aplicației sunt doar woff2, §25.4),
   transliterăm sigur la ASCII: textul rămâne lizibil și lățimile corecte.
   Folosit de TOATE exporturile jsPDF (regulament + istoric). */
function _pdfSafe(s) {
    const MAP = { 'ă': 'a', 'Ă': 'A', 'â': 'a', 'Â': 'A', 'î': 'i', 'Î': 'I', 'ș': 's', 'Ș': 'S', 'ş': 's', 'Ş': 'S', 'ț': 't', 'Ț': 'T', 'ţ': 't', 'Ţ': 'T' };
    return String(s == null ? '' : s)
        .replace(/[ăĂâÂîÎșȘşŞțȚţŢ]/g, c => MAP[c] || c)
        .normalize('NFKD').replace(/[\u0300-\u036f]/g, ''); /* orice alt accent combinat (é, ü…) */
}

/* R1: exportRegulationPDF ... updateRegulationArticle → regulation.js. */

/* ================= ADMIN FUNCTIONS ================= */
/* RO: Opt-out MANUAL din panoul de Admin („Ieși din admin"). Înainte, butonul ăla
       scria `isAdmin = false` — un flag GLOBAL folosit de zeci de alte gărzi — deci
       ieșirea din panou îți lua și butoanele din Catalog, Jucători etc. până la
       următorul `applyClubRole`. Acum ascunderea e strict locală panoului.
   EN: local-only opt-out; the old one flipped the global `isAdmin` flag. */
let _adminPanelOptOut = false;

function renderAdmin() {
    if (!state.currentUser) return;
    
    const adminLoginScreen = document.getElementById('adminLoginScreen');
    const adminPanel = document.getElementById('adminPanel');
    
    /* RO: Decizia vine din stratul de capabilități — o SINGURĂ sursă: rolul din
           CLUBUL ACTIV (`currentClubMyRole()` -> rang). `member.manage` e exact
           capabilitatea cerută de tab-ul Admin (`data-cap="member.manage"` în
           index.html), deci meniul, `switchTab` și panoul răspund identic.

           Ce era înainte, și de ce era periculos:
             if (state.currentUser.role === 'admin') { isAdmin = true; }
           `state.currentUser.role` e scris în DOUĂ locuri cu înțelesuri diferite —
           `onAuthenticated` îl ia din `profiles.role` (rol GLOBAL de platformă),
           `applyClubRole` din rolul de club. Iar atribuirea era un ZĂVOR: ridica
           `isAdmin` la true și nu-l cobora niciodată. `renderAdmin()` e apelat
           necondiționat din `renderAll()`, deci un cont cu rol global „admin",
           simplu membru în clubul curent, ajungea cu `isAdmin = true` — flag care
           contamina apoi toate celelalte gărzi construite pe el.
       EN: capability-based, club-scoped; the old check latched the global `isAdmin`
           flag from an ambiguous role field and never cleared it. */
    const _mayAdmin = ((typeof can === 'function') ? can('member.manage') : !!isAdmin) && !_adminPanelOptOut;
    
    if (_mayAdmin) {
        adminLoginScreen.classList.add('hidden');
        adminPanel.classList.remove('hidden');
        renderEloAdminControl();
        try { if (typeof _scTplDraft !== 'undefined') _scTplDraft = null; if (typeof renderScoringTemplatesAdmin === 'function') renderScoringTemplatesAdmin(); } catch (e) { logError('renderAdmin', e); }
        const msel = document.getElementById('seasonMonthSelect');
        if (msel) {
            const cur = state.seasonMonth || (new Date().getMonth() + 1);
            const names = ['Ianuarie','Februarie','Martie','Aprilie','Mai','Iunie','Iulie','August','Septembrie','Octombrie','Noiembrie','Decembrie'];
            msel.innerHTML = names.map((nm, i) => `<option value="${i + 1}" ${i + 1 === cur ? 'selected' : ''}>${i + 1} — ${window.escHtml(nm)}</option>`).join('');
        }
        const ysel = document.getElementById('seasonYearSelect');
        if (ysel) {
            const nowY = new Date().getFullYear();
            const curY = state.seasonYear || nowY;
            const years = [];
            for (let y = nowY - 3; y <= nowY + 2; y++) years.push(y);
            if (years.indexOf(curY) === -1) years.push(curY);
            years.sort((a, b) => a - b);
            ysel.innerHTML = years.map(y => `<option value="${y}" ${y === curY ? 'selected' : ''}>${y}</option>`).join('');
        }
        if (typeof renderSeasonArchives === 'function') renderSeasonArchives();
        renderAdminUsersList();
        renderAuditLog();
        /* ⚡ PERF §54.4 (Batch 2b) — încărcăm rapoartele DOAR când tabul Admin e deschis.
           RO: `renderModerationPanel()` cere TOATE rapoartele clubului (`select=*`, până
               la 200 de rânduri) plus o rezolvare de nume peste ele. Rula însă la FIECARE
               `render()`, fiindcă `render()` cheamă `renderAdmin()` necondiționat —
               deci și când utilizatorul era pe Dashboard și nu deschisese niciodată
               panoul de moderare. Confirmat în captura de rețea, 22.08.2026: cererea
               `reports?select=*` pleca la pornire, cu panoul închis.
               Intrarea în tab rămâne acoperită: `switchTab('admin')` (app-core.js:1973)
               cheamă direct `renderAdmin()`, deci panoul se populează normal la deschidere.
               Exact tiparul folosit deja pentru `loadChat()` în faza 1 (§54.4).
           EN: the moderation panel pulled every report (up to 200 rows) on every
               `render()`, even on the Dashboard with the panel never opened. Guarded on
               the active tab; `switchTab('admin')` still calls `renderAdmin()` directly,
               so opening the tab populates it as before. Same pattern as `loadChat()`. */
        try {
            if (typeof renderModerationPanel === 'function' && currentTab === 'admin') renderModerationPanel();
        } catch (e) { logError('renderAdmin', e); }
    } else {
        adminLoginScreen.classList.remove('hidden');
        adminPanel.classList.add('hidden');
    }
}

function loginAdmin() {
    /* Accesul se decide din rolul din CLUBUL ACTIV, prin stratul de capabilități.
       Nicio parolă în cod și nicio scriere pe `isAdmin`: flagul global e stabilit
       exclusiv de `applyClubRole()`, ca să existe o singură sursă. */
    if (typeof can === 'function' ? can('member.manage') : !!isAdmin) {
        _adminPanelOptOut = false;
        renderAdmin();
        showNotification(t('m3.adminAccessOn'), 'success');
        addAuditLog('audit.adminLogin', state.currentUser.name, { key: 'auditd.roleVerifiedDb' });
    } else {
        renderAdmin();
        showNotification(t('m3.notAdmin'), 'error');
    }
}

function logoutAdmin() {
    /* Ascunde DOAR panoul. Vezi nota de la `_adminPanelOptOut`: înainte se scria
       `isAdmin = false`, ceea ce îți lua permisiunile și în restul aplicației. */
    _adminPanelOptOut = true;
    renderAdmin();
    switchTab('dashboard');
    showNotification(t('m3.adminAccessOff'), 'success');
}

/* ⚠ 9.6 — COD MORT, ELIMINAT (sept. 2026).
   Aici trăiau trei funcții — `renderAdminUsersList`, `toggleAdminStatus`, `deleteUser` —
   redefinite TOATE în `supabase-integration.js`, care se încarcă DUPĂ acest fișier
   (ordinea din index.html). În scripturi clasice, ultima declarație câștigă, deci
   versiunile de aici nu s-au executat niciodată. Verificat prin rulare, nu prin citire.
   De ce contează: tabelul de aici afișa adresa de email FĂRĂ nicio verificare de
   `hide_email` și o trecea și printr-un `onclick`. Arăta ca o scurgere de date personale
   într-o căutare prin cod — și chiar a fost raportată ca atare — deși nu putea rula.
   Un defect fantomă costă timp de fiecare dată când cineva citește fișierul.
   Versiunile vii sunt în `supabase-integration.js`: `renderAdminUsersList` (cu paginare,
   căutare și roluri), `toggleAdminStatus` și `deleteUser` (ambele pe id, cu verificări).
   EN: three functions here were shadowed by later redefinitions and never ran; the dead
   table also rendered emails with no hide_email guard, which read as a privacy leak. */


function renderAdminScoreEditor() {
    const container = document.getElementById('adminScoreEditor');
    if (!container) return;
    
    const players = getSortedPlayers();
    
    container.innerHTML = `
        <table class="table-responsive" style="margin-top: 10px;">
            <thead>
                <tr>
                    <th>${t('stats.player')}</th>
                    <th>${t('adm.currentScore')}</th>
                    <th>${t('stats.games')}</th>
                    <th>${t('adm.newScore')}</th>
                    <th>${t('adm.action')}</th>
                </tr>
            </thead>
            <tbody>
                ${players.map(player => `
                    <tr>
                        <td>${window.escHtml(player.name)}</td>
                        <td>${player.score.toFixed(1)}</td>
                        <td>${player.gamesPlayed}</td>
                        <td>
                            <input type="number" 
                                   step="${POINTS_STEP}" 
                                   id="edit-score-${player.name.replace(/[^a-zA-Z0-9]/g, '-')}" 
                                   class="form-control" 
                                   style="width: 100px; display: inline-block;"
                                   value="${player.score}">
                        </td>
                        <td>
                            <button class="btn btn-sm btn-success" onclick="updatePlayerScore('${window.attrJs(player.name)}')">
                                ${t('admin.update')}
                            </button>
                        </td>
                    </tr>
                `).join('')}
            </tbody>
        </table>
    `;
}

function updatePlayerScore(playerName) {
    if (!isAdmin) return;
    
    const input = document.getElementById(`edit-score-${playerName.replace(/[^a-zA-Z0-9]/g, '-')}`);
    const newScore = parseFloat(input.value);
    
    if (isNaN(newScore) || newScore < 0) {
        showNotification(t('m1.invalidScore'), 'error');
        return;
    }
    
    if (!state.members[playerName]) return;
    
    const oldScore = state.members[playerName].score;
    state.members[playerName].score = newScore;
    
    saveState();
    renderAdminScoreEditor();
    renderDashboard();
    
    addAuditLog('audit.playerScoreManual', state.currentUser.name, 
        `${playerName}: ${oldScore.toFixed(1)} → ${newScore.toFixed(1)}`);
    
    showNotification(t('m3.scoreUpdatedFor').replace('{name}', playerName), 'success');
}

let auditPage = 1;
function auditSearchChanged() { auditPage = 1; renderAuditLog(); }
function goToAuditPage(p) { auditPage = p; renderAuditLog(); }
function renderAuditLog() {
    const container = document.getElementById('auditLog');
    if (!container) return;
    const esc = s => window.escHtml(s);
    const q = (document.getElementById('auditSearch') ? document.getElementById('auditSearch').value : '').trim().toLowerCase();

    let logs = (state.audit || []).slice().reverse(); /* cele mai recente primele */
    /* Filtrare strictă pe clubul curent (intrările vechi fără clubId nu se mai amestecă). */
    if (typeof currentClubId !== 'undefined' && currentClubId) {
        logs = logs.filter(l => l.clubId === currentClubId);
    }
    if (q) {
        logs = logs.filter(l => [l.action, l.user, l.details].filter(Boolean).join(' ').toLowerCase().includes(q));
    }

    if (logs.length === 0) {
        container.innerHTML = '<p class="text-center text-muted">' + t('adm.noAudit') + '</p>';
        const pag = document.getElementById('auditPagination'); if (pag) pag.innerHTML = '';
        return;
    }

    const perPage = 20;
    const totalPages = Math.ceil(logs.length / perPage);
    let page = Math.min(Math.max(1, auditPage || 1), totalPages || 1);
    auditPage = page;
    const slice = logs.slice((page - 1) * perPage, page * perPage);

    container.innerHTML = slice.map(log => `
        <div class="audit-entry">
            <div class="audit-time">${new Date(log.timestamp).toLocaleString('en-GB')}</div>
            <div class="audit-action">
                <strong>${esc(log.user)}:</strong> ${esc(t(log.action))}
                ${log.details ? `<br><small style="color: var(--text-secondary);">${esc(log.details)}</small>` : ''}
            </div>
        </div>
    `).join('');

    const pag = document.getElementById('auditPagination');
    if (pag) {
        if (totalPages <= 1) { pag.innerHTML = ''; }
        else {
            let h = `<div style="display:flex; justify-content:center; align-items:center; gap:10px; flex-wrap:wrap;">
                <span style="color:var(--text-secondary);">${logs.length} ${t('admin.entries')} • ${t('common.page')} ${page}/${totalPages}</span>`;
            if (page > 1) h += `<button class="btn btn-sm" onclick="goToAuditPage(${page - 1})"><i class="fas fa-chevron-left"></i> Anterior</button>`;
            if (page < totalPages) h += `<button class="btn btn-sm" onclick="goToAuditPage(${page + 1})">${t('common.next')} <i class="fas fa-chevron-right"></i></button>`;
            h += `</div>`;
            pag.innerHTML = h;
        }
    }
}

function addAuditLog(action, user, details = '') {
    if (!Array.isArray(state.audit)) state.audit = []; /* gardă: jurnalul funcționează chiar dacă starea a fost resetată */
    const logEntry = {
        id: Date.now(),
        timestamp: new Date().toISOString(),
        clubId: (typeof currentClubId !== 'undefined' ? currentClubId : null), /* per club */
        action,
        user,
        details,
        ip: getUserIP(),
        userAgent: navigator.userAgent
    };
    
    state.audit.push(logEntry);
    
    // Păstrăm un istoric generos, fără să ștergem inutil (persistență per browser)
    if (state.audit.length > 5000) {
        state.audit = state.audit.slice(-5000);
    }
    
    saveState();
}

/* ⚠ RETRASĂ (iulie 2026). Indicatorul „Ultima salvare" a fost scos din panoul de
   setări din două motive: textul era HARDCODAT în română (deci apărea așa și
   pentru utilizatorii pe engleză), iar de la trecerea la Supabase salvarea e
   continuă — o oră afișată nu mai spune nimic util.
   ⚠ Prima încercare de eliminare a fost INCOMPLETĂ: am scos elementul din
   `index.html`, dar funcția asta avea o ramură `else` care îl RECREA, poziționat
   absolut peste butoanele din header. De aceea funcția trebuie neutralizată aici,
   nu doar în HTML. O păstrăm ca no-op (e apelată din mai multe locuri) și, dacă
   elementul e totuși prezent, îl actualizăm prin `t()`, nu cu text fix.
   EN: retired. Removing the element from HTML was not enough — this function
   re-created it, absolutely positioned over the header buttons. */
function updateLastSaveIndicator() {
    const indicator = document.getElementById('lastSaveIndicator');
    if (!indicator) return;                       /* nu îl mai CREĂM niciodată */
    try { indicator.textContent = (typeof t === 'function') ? t('admin.autosaveActive') : ''; }
    catch (e) { /* i18n indisponibil */ }
}

/* ================= BACKUP & RESTORE ================= */
/* Sesiunile din state -> format pentru import_matches_bulk (câmpuri = coloanele
   `matches`). Folosit la EXPORT (le serializăm) și la IMPORT (le citim). */
function _sessionToBackupRow(g) {
    return {
        game_title: g.gameName || g.game_title || '',
        date: g.timestamp || g.date || null,
        players: g.participants || g.players || [],
        scores: g.scores || {},
        winners: g.winners || [],
        club_points: g.clubPoints || g.club_points || {},
        recorded_by: g.recordedBy || g.recorded_by || '',
        meta: g.meta || {},
        idem_key: g.idemKey || g.idem_key || null
    };
}
function _sessionsForImport(d) {
    if (Array.isArray(d.sessions)) return d.sessions;
    if (Array.isArray(d.matches)) return d.matches;
    if (Array.isArray(d.games) && d.games.length && (d.games[0].game_title || d.games[0].participants)) return d.games.map(_sessionToBackupRow);
    return [];
}

/* Backup „sanitizat" (golden standard, §10/§24): exportă STRUCTURA clubului
   pentru recuperare/migrare, FĂRĂ PII de contact. Emailuri, currentUser, jurnal
   de audit, preferințe personale și notificări NU sunt incluse — conturile reale
   se re-leagă prin `id` din Supabase la restaurare, deci emailul nu e necesar.
   Membrii sunt păstrați cu id + nume de afișare (oricum publice în club). */
/* `_sanitizeMemberForBackup` a fost ELIMINAT odată cu exportul din client.
   Sanitizarea nu mai e o listă albă scrisă de mână în JS, ci un DENYLIST pe nume
   de coloană, aplicat server-side în `private.backup_columns` — vezi
   `05_club_backups.sql`. Diferența contează: o coloană nouă cu date sensibile
   (`email`, `stripe_*`) nu mai poate intra tăcut în backup fiindcă a uitat
   cineva să actualizeze lista din client.
   ⚠ KB §26(b) descrie mecanismul vechi și trebuie actualizat. */

/* ===== BACKUP DE CLUB — creare, descărcare, istoric ==========================
   RO: Rescris integral. Versiunea veche serializa forma din CLIENT
       (`state.catalog`, `state.games` transformate) și scria istoricul în
       `state.backups` + `saveState()` — care persistă local doar
       {settings, audit, lastSaved}. Consecințe, ambele confirmate:
         1. istoricul dispărea la primul refresh;
         2. backup-ul conținea 12 câmpuri din client, iar restaurarea repunea
            în baza de date doar 4 (games, matches, regulation, seasons) —
            evenimentele, anunțurile, turneele, campaniile, poll-urile și
            setările clubului nu erau salvate deloc.

       Acum: backup-ul se asamblează SERVER-SIDE (RPC `club_backup_create`), din
       rândurile brute ale tabelelor, și se păstrează în `club_backups` (RLS
       rang>=3). Clientul doar cere crearea și descarcă fișierul.
   EN: full rewrite — server-side assembly from raw rows, persisted in the DB.
   ============================================================================ */

/* Gărzile comune pentru toate operațiile de backup. Întoarce true dacă se poate
   continua; altfel a afișat deja motivul. */
function _bkpReady() {
    if (typeof isDemoMode === 'function' && isDemoMode()) {
        showNotification(t('sb.demoNoSaveChanges'), 'info');
        return false;
    }
    if (typeof can === 'function' ? !can('backup.export') : !isAdmin) {
        showNotification(t('rbac.noPermission'), 'error');
        return false;
    }
    if (typeof sb === 'undefined' || !sb || typeof currentClubId === 'undefined' || !currentClubId) {
        showNotification(t('bkp.noClub'), 'error');
        return false;
    }
    return true;
}

/* Fișierul descărcat poartă un marcaj de format explicit. Fără el, restaurarea
   n-ar putea distinge un backup nou (rânduri brute) de unul vechi (forma din
   client) și ar încerca să-l citească greșit. */
function _bkpDownloadRow(row) {
    const club = (typeof activeClub === 'function') ? activeClub() : null;
    const file = {
        format: 'turnorder-club-backup',
        formatVersion: 2,
        clubId: (row && row.club_id) || currentClubId,
        clubName: (club && club.name) || '',
        backupId: row && row.id,
        createdAt: (row && row.created_at) || new Date().toISOString(),
        tables: (row && row.payload) || {}
    };
    const txt = JSON.stringify(file, null, 2);
    const blob = new Blob([txt], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'turnorder-backup-' + String(file.createdAt).slice(0, 10) + '.json';
    link.click();
    URL.revokeObjectURL(url);
    return txt.length;
}

async function exportFullBackup() {
    if (!_bkpReady()) return;

    showNotification(t('bkp.creating'), 'info');

    const res = await sb.rpc('club_backup_create', { p_club_id: currentClubId, p_kind: 'manual' });
    if (res.error) {
        logError('exportFullBackup', res.error);
        showNotification(t('bkp.error').replace('{msg}', res.error.message || ''), 'error');
        return;
    }
    const info = res.data || {};

    /* `skipped` = nimic nu s-a schimbat de la ultimul backup, deci serverul n-a
       stocat o copie identică. Utilizatorul primește totuși fișierul — descărcăm
       cel mai recent backup existent. */
    let q = sb.from('club_backups').select('id, club_id, created_at, payload').eq('club_id', currentClubId);
    q = info.id ? q.eq('id', info.id) : q.order('created_at', { ascending: false }).limit(1);
    const got = await q.maybeSingle();
    if (got.error || !got.data) {
        logError('exportFullBackup.fetch', got.error);
        showNotification(t('bkp.error').replace('{msg}', (got.error && got.error.message) || ''), 'error');
        return;
    }

    _bkpDownloadRow(got.data);
    addAuditLog('audit.fullBackupExported', state.currentUser.name);
    showNotification(info.skipped ? t('bkp.unchanged') : t('bkp.created'), 'success');

    /* Dacă istoricul e deschis, îl reîmprospătăm ca să apară intrarea nouă. */
    if (document.getElementById('bkpHistoryModal')) { try { await showBackupHistory(); } catch (e) { logError('exportFullBackup.refresh', e); } }
}

/* Descarcă un backup deja existent, din istoric. Payload-ul NU e adus în listă
   (ar însemna sute de KB per rând) — abia aici, pentru un singur id. */
async function downloadClubBackup(id) {
    if (!_bkpReady()) return;
    const res = await sb.from('club_backups')
        .select('id, club_id, created_at, payload')
        .eq('id', id).maybeSingle();
    if (res.error || !res.data) {
        showNotification(t('bkp.error').replace('{msg}', (res.error && res.error.message) || ''), 'error');
        return;
    }
    _bkpDownloadRow(res.data);
}
window.downloadClubBackup = downloadClubBackup;

async function restoreBackup(input) {
    /* RO: garda era `if (!isAdmin)`. `isAdmin` are TREI scriitori cu înțelesuri
           diferite — `onAuthenticated` (rolul GLOBAL din `profiles.role`),
           `applyClubRole` (rolul din CLUBUL ACTIV) și `renderAdmin`, care îl ridică
           la `true` fără să-l coboare vreodată. Cine rulează ultimul câștigă, deci
           imediat după autentificare sau după o vizită în panoul de Admin garda
           putea răspunde despre alt club decât cel curent.
           `can('backup.restore')` are o singură sursă: rolul din clubul activ
           (`currentClubMyRole()` -> rang), aliniat exact cu pragul rang>=3 impus de
           `import_games_bulk`, `import_matches_bulk` și RLS-ul de pe `club_settings`.
           Pentru un admin legitim NU se schimbă nimic; dispare doar fereastra în care
           garda putea răspunde greșit.
       EN: replaced the ambiguous `isAdmin` flag (three writers, two meanings) with the
           club-scoped capability layer, aligned with the rank>=3 the server enforces. */
    if (typeof isDemoMode === 'function' && isDemoMode()) {
        /* Gardă de demo ÎNAINTE de citirea fișierului: partea de DB era deja protejată,
           dar `state[k] = d[k]` de mai jos rula oricum și suprapunea backup-ul peste
           datele fictive => stare hibridă, fără nimic salvat nicăieri. */
        showNotification(t('sb.demoNoSaveChanges'), 'info');
        input.value = '';
        return;
    }
    if (typeof requireWritableClub === 'function' && !requireWritableClub()) {
        input.value = '';
        return;
    }
    if (typeof can === 'function' ? !can('backup.restore') : !isAdmin) {
        showNotification(t('m3.onlyAdminRestore'), 'error');
        input.value = '';
        return;
    }

    const file = input.files[0];
    if (!file) return;

    /* ⚠ Confirmarea NU se mai cere aici. Motivul: fișierul nu e încă citit, deci nu
       știm ce fel de backup e. Un fișier de format nou primea întâi avertismentul
       generic de mai jos, apoi pe cel corect din `_restoreFromFilePayload` — două
       ferestre pentru aceeași apăsare. Fiecare drum își cere acum propria
       confirmare, după ce știe cu ce are de-a face. */
    const reader = new FileReader();
    reader.onload = async function (e) {
        try {
            const backup = JSON.parse(e.target.result);

            /* RO: Fișierele de format nou conțin rânduri BRUTE din tabele. Merg pe
                   ACELAȘI drum ca restaurarea din istoric (`private.restore_payload`),
                   nu pe traseul vechi de mai jos, care repunea 4 lucruri din 20.
                   Fișierele vechi (fără marcaj de format) rămân pe traseul vechi.
               EN: new-format files go through the same RPC core as the history
                   restore; legacy files keep the old path. */
            if (backup && backup.format === 'turnorder-club-backup') {
                input.value = '';
                await _restoreFromFilePayload(backup);
                return;
            }

            /* Confirmarea pentru traseul VECHI (fișiere fără marcaj de format). */
            if (!await confirmModal(t('m3.confirmRestore'), { danger: true })) {
                input.value = '';
                return;
            }

            // Validare structură
            if (!backup || !backup.data || !backup.version) {
                throw new Error('invalid');
            }
            const d = backup.data;

            /* 1) Structura locală (fallback instant + settings fără sursă DB proprie). */
            const restorable = ['catalog', 'members', 'membersById',
                'locations', 'categories', 'scoringTemplates', 'gameRoles', 'settings'];
            restorable.forEach(k => { if (k in d) state[k] = d[k]; });

            /* 2) Re-populare REALĂ în DB (golden standard, cross-device) prin RPC-uri
               idempotente. Doar dacă suntem online, non-demo, cu club selectat. */
            let report = '';
            if (sb && currentClubId && !(typeof isDemoMode === 'function' && isDemoMode())) {
                showNotification(t('m3.restoreImporting'), 'info');
                try {
                    /* Catalog (obiect {titlu:{...}}) -> array de jocuri pt. RPC. */
                    let gamesArr = [];
                    if (d.catalog && typeof d.catalog === 'object') {
                        gamesArr = Object.keys(d.catalog).map(titlu => {
                            const c = d.catalog[titlu] || {};
                            return {
                                title: c.title || titlu, min_players: c.minPlayers, max_players: c.maxPlayers,
                                duration: c.duration, complexity: c.difficulty ?? c.complexity,
                                category: Array.isArray(c.categories) ? c.categories.join(', ') : c.category,
                                description: c.description, owner: c.owner, image_url: c.image || c.image_url,
                                bgg_id: c.bggId || c.bgg_id, base_rating: c.baseRating, min_age: c.minAge,
                                designer: c.designer, artist: c.artist, publisher: c.publisher, edition: c.edition
                            };
                        });
                    }
                    if (gamesArr.length) {
                        const rg = await sb.rpc('import_games_bulk', { p_club_id: currentClubId, p_games: gamesArr });
                        if (rg.error) throw rg.error;
                        report += (rg.data ? `${t('m3.games')}: +${rg.data.inserted} ` : '');
                    }
                    const sessions = _sessionsForImport(d);
                    if (sessions.length) {
                        const rm = await sb.rpc('import_matches_bulk', { p_club_id: currentClubId, p_matches: sessions });
                        if (rm.error) throw rm.error;
                        report += (rm.data ? `${t('m3.sessions')}: +${rm.data.inserted}` : '');
                    }
                    /* Regulament + sezoane -> club_settings (upsert existent, RLS rang>=3). */
                    if (d.regulation) {
                        await sb.from('club_settings').upsert({ club_id: currentClubId, key: 'regulation', value: d.regulation, updated_at: new Date().toISOString() }, { onConflict: 'club_id,key' });
                    }
                    if (Array.isArray(d.seasons)) {
                        await sb.from('club_settings').upsert({ club_id: currentClubId, key: 'season_archives', value: d.seasons, updated_at: new Date().toISOString() }, { onConflict: 'club_id,key' });
                    }
                } catch (rpcErr) {
                    console.error('restore import:', rpcErr);
                    showNotification(t('m3.restoreImportError') + (rpcErr.message || ''), 'error');
                    input.value = '';
                    return;
                }
            }

            saveState();
            input.value = '';

            addAuditLog('audit.backupRestored', state.currentUser.name,
                (backup.exportedAt ? new Date(backup.exportedAt).toLocaleString('en-GB') : '') + (report ? ' — ' + report : ''));

            showNotification(t('m3.restoreDone'), 'success');
            /* Re-hidratăm din DB (nu reload brutal) ca să reflectăm importul real. */
            setTimeout(async () => {
                try { if (typeof hydrateFromSupabase === 'function') { await hydrateFromSupabase(); render(); } else location.reload(); }
                catch (e) { location.reload(); }
            }, 700);
        } catch (error) {
            console.error('Error restoring backup:', error);
            showNotification(t('m3.restoreError'), 'error');
            input.value = '';
        }
    };

    reader.readAsText(file);
}

async function showBackupHistory() {
    if (!_bkpReady()) return;

    /* Lista NU cere `payload`: un singur backup are sute de KB, iar 21 de rânduri
       ar însemna megaocteți transferați degeaba. Payload-ul se aduce abia la
       apăsarea butonului de descărcare, pentru un singur id. */
    const res = await sb.from('club_backups')
        .select('id, kind, created_at, created_by_name, size_bytes, last_auto_check')
        .eq('club_id', currentClubId)
        .order('created_at', { ascending: false });

    if (res.error) {
        logError('showBackupHistory', res.error);
        showNotification(t('bkp.error').replace('{msg}', res.error.message || ''), 'error');
        return;
    }
    const rows = res.data || [];
    if (!rows.length) {
        showNotification(t('m3.noBackupHistory'), 'info');
        return;
    }

    const old = document.getElementById('bkpHistoryModal');
    if (old) old.remove();

    const esc = window.escHtml;
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.id = 'bkpHistoryModal';
    modal.innerHTML = `
        <div class="modal-content" style="max-width:720px;">
            <div class="modal-header">
                <h2><i class="fas fa-history"></i> ${esc(t('bkp.historyTitle'))}</h2>
                <button class="modal-close" onclick="this.closest('.modal').remove()">×</button>
            </div>
            <p style="color:var(--text-secondary); font-size:.86em; margin-bottom:6px;">
                <i class="fas fa-circle-info"></i> ${esc(t('bkp.retentionNote'))}
            </p>
            <p style="color:var(--text-secondary); font-size:.86em; margin-bottom:12px;">
                <i class="fas fa-image"></i> ${esc(t('bkp.coverageNote'))}
            </p>
            <div class="table-responsive" style="max-height:50vh; overflow-y:auto;">
                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th>${esc(t('bkp.colDate'))}</th>
                            <th>${esc(t('bkp.colKind'))}</th>
                            <th>${esc(t('bkp.colBy'))}</th>
                            <th>${esc(t('admin.size'))}</th>
                            <th style="text-align:center;">${esc(t('bkp.download'))}</th>
                            <th style="text-align:center;">${esc(t('bkp.restore'))}</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${rows.map(b => {
                            const d = new Date(b.created_at);
                            const kb = Math.max(1, Math.round((b.size_bytes || 0) / 1024));
                            const kind = (b.kind === 'auto') ? t('bkp.kindAuto') : t('bkp.kindManual');
                            const by = b.created_by_name || ((b.kind === 'auto') ? t('bkp.bySystem') : '—');
                            /* Ștampila de verificare automată: un club nemodificat nu produce
                               backup nou, iar fără linia asta istoricul ar arăta identic în
                               două situații opuse — „verificat zilnic, nimic nou" și „backup-ul
                               automat s-a stricat acum o lună". */
                            const chk = b.last_auto_check ? new Date(b.last_auto_check) : null;
                            const chkHtml = (chk && isFinite(chk.getTime()))
                                ? `<div style="font-size:.78em; opacity:.7; overflow-wrap:anywhere;">${esc(t('bkp.lastCheck').replace('{date}', chk.toLocaleString('en-GB')))}</div>`
                                : '';
                            return `
                                <tr>
                                    <td>${esc(isFinite(d.getTime()) ? d.toLocaleString('en-GB') : '—')}${chkHtml}</td>
                                    <td>${esc(kind)}</td>
                                    <td style="overflow-wrap:anywhere;">${esc(by)}</td>
                                    <td>${kb} KB</td>
                                    <td style="text-align:center;">
                                        <button class="btn btn-sm btn-secondary" title="${esc(t('bkp.download'))}" aria-label="${esc(t('bkp.download'))}" onclick="downloadClubBackup(${Number(b.id)})">
                                            <i class="fas fa-download"></i>
                                        </button>
                                    </td>
                                    <td style="text-align:center;">
                                        <button class="btn btn-sm btn-danger" title="${esc(t('bkp.restore'))}" aria-label="${esc(t('bkp.restore'))}" onclick="restoreClubBackup(${Number(b.id)}, '${window.attrJs(b.created_at || '')}')">
                                            <i class="fas fa-clock-rotate-left"></i>
                                        </button>
                                    </td>
                                </tr>`;
                        }).join('')}
                    </tbody>
                </table>
            </div>
            <div class="btn-group" style="margin-top:20px;">
                <button class="btn btn-secondary" onclick="this.closest('.modal').remove()">
                    <i class="fas fa-times"></i> ${esc(t('common.close'))}
                </button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
}
window.showBackupHistory = showBackupHistory;

/* Restaurează un backup din istoric peste clubul curent.
   RO: Cea mai distructivă operație din aplicație, deci trei bariere înainte de
       apel: capabilitatea, avertismentul explicit despre ce NU se recuperează, și
       tastarea numelui clubului. Un `confirmModal` simplu se apasă din reflex. */
async function restoreClubBackup(id, createdAt) {
    if (!_bkpReady()) return;
    /* `backup.restore` (rang 3), aliniat cu pragul din RPC. `backup.export` din
       `_bkpReady` e la fel de strict, dar verificăm explicit capabilitatea corectă
       ca schimbarea unui prag să nu treacă tăcut prin gardă greșită. */
    if (typeof can === 'function' && !can('backup.restore')) {
        showNotification(t('rbac.noPermission'), 'error');
        return;
    }

    /* Clubul se CAPTUREAZĂ la început și se folosește peste tot. Între avertisment,
       parolă și RPC trec secunde bune în care clubul activ se poate schimba — fie
       fiindcă utilizatorul comută, fie printr-o reîmprospătare realtime. Fără
       captură, restaurarea ar viza alt club decât cel din avertisment. */
    const clubIdStart = currentClubId;
    const club = (typeof activeClub === 'function') ? activeClub() : null;
    const clubName = (club && club.name) || '';
    const d = createdAt ? new Date(createdAt) : null;
    const cand = (d && isFinite(d.getTime())) ? d.toLocaleString('en-GB') : '—';

    if (!await confirmModal(
            t('bkp.restoreWarn').replace('{date}', cand).replace('{club}', clubName),
            { danger: true })) return;

    /* A doua barieră: PAROLA, prin același strat ca la ban, transfer de club sau
       ștergere de cont (`REAUTH_ACTIONS`). Am renunțat la tastarea numelui clubului:
       un singur ritual pentru toate acțiunile grave e mai ușor de învățat și mai
       greu de trecut din reflex decât două mecanisme diferite. */
    if (typeof requireReauth === 'function' && !await requireReauth('backup.restore')) return;

    showNotification(t('bkp.restoring'), 'info');
    const res = await sb.rpc('club_backup_restore', { p_backup_id: id, p_club_id: clubIdStart });
    if (res.error) {
        logError('restoreClubBackup', res.error);
        const msg = String(res.error.message || '');
        /* Mesajul de nepotrivire de club vine din baza de date cu numele ambelor
           cluburi în el — îl arătăm ca atare, e mai clar decât orice reformulare. */
        showNotification(/CLUB_MISMATCH/.test(msg)
            ? msg.replace(/^.*CLUB_MISMATCH:\s*/, '')
            : t('bkp.error').replace('{msg}', msg), 'error');
        return;
    }

    await _bkpAfterRestore(res.data || {}, id, clubIdStart);
}

/* Pașii de după orice restaurare, indiferent de drum (istoric sau fișier):
   rehidratare, audit, raport cu cele trei numere separate. */
async function _bkpAfterRestore(r, sursaId, clubIdStart) {
    /* Rehidratare: după o scriere masivă, tot ce e în memorie e vechi. */
    if (typeof hydrateFromSupabase === 'function') await hydrateFromSupabase();
    if (typeof renderAll === 'function') renderAll();

    if (state.currentUser) {
        addAuditLog('audit.backupRestored', state.currentUser.name,
            { key: 'auditd.backupRestoredDetail', params: { id: sursaId, n: r.randuri_scrise || 0 } });
    }

    let msg = t('bkp.restoreDone')
        .replace('{n}', String(r.randuri_scrise || 0))
        .replace('{snap}', String(r.snapshot_id || '—'));
    if (r.randuri_sarite) msg += ' ' + t('bkp.restoreSkipped').replace('{n}', String(r.randuri_sarite));
    if (r.referinte_golite) msg += ' ' + t('bkp.restoreNulled').replace('{n}', String(r.referinte_golite));
    showNotification(msg, 'success');

    /* Redeschidem istoricul DOAR dacă suntem încă în același club. Altfel am afișa
       istoricul altui club imediat după o restaurare — exact confuzia raportată. */
    if (document.getElementById('bkpHistoryModal')) {
        if (clubIdStart && currentClubId !== clubIdStart) {
            document.getElementById('bkpHistoryModal').remove();
        } else {
            try { await showBackupHistory(); } catch (e) { logError('restore.refresh', e); }
        }
    }
}
window.restoreClubBackup = restoreClubBackup;

/* Restaurare dintr-un FIȘIER de format nou. Aceleași bariere ca la restaurarea din
   istoric: capabilitate, avertisment, parolă — plus verificarea clubului din fișier,
   făcută aici ca mesajul să poarte ambele nume. Serverul o refiltrează oricum:
   `private.restore_table` respinge rândurile care nu aparțin clubului-țintă. */
async function _restoreFromFilePayload(file) {
    if (!_bkpReady()) return;
    if (typeof can === 'function' && !can('backup.restore')) {
        showNotification(t('rbac.noPermission'), 'error');
        return;
    }
    const clubIdStart = currentClubId;
    const club = (typeof activeClub === 'function') ? activeClub() : null;
    const clubName = (club && club.name) || '';

    if (!file.tables || typeof file.tables !== 'object' || Array.isArray(file.tables)) {
        showNotification(t('bkp.fileInvalid'), 'error');
        return;
    }
    if (file.clubId && file.clubId !== clubIdStart) {
        showNotification(t('bkp.fileOtherClub')
            .replace('{from}', file.clubName || file.clubId)
            .replace('{to}', clubName), 'error');
        return;
    }

    const d = file.createdAt ? new Date(file.createdAt) : null;
    const cand = (d && isFinite(d.getTime())) ? d.toLocaleString('en-GB') : '—';
    if (!await confirmModal(
            t('bkp.restoreWarn').replace('{date}', cand).replace('{club}', clubName),
            { danger: true })) return;
    if (typeof requireReauth === 'function' && !await requireReauth('backup.restore')) return;

    showNotification(t('bkp.restoring'), 'info');
    const res = await sb.rpc('club_backup_restore_file', { p_club_id: clubIdStart, p_payload: file.tables });
    if (res.error) {
        logError('_restoreFromFilePayload', res.error);
        showNotification(t('bkp.error').replace('{msg}', res.error.message || ''), 'error');
        return;
    }
    await _bkpAfterRestore(res.data || {}, file.backupId || 0, clubIdStart);
}



/* ================= SEASON MANAGEMENT ================= */
async function startNewSeason() {
    /* `settings.edit` (rang 3) în loc de `isAdmin`: aliniat cu RLS-ul de pe
       `club_settings` (insert/update rang>=3), unde ajung arhivele și sezonul.
       `isAdmin` avea trei scriitori cu două înțelesuri — vezi nota din renderAdmin. */
    if (typeof requireWritableClub === 'function' && !requireWritableClub()) return;
    if (typeof can === 'function' ? !can('settings.edit') : !isAdmin) { showNotification(t('m3.onlyAdminSeasons'), 'error'); return; }
    if (!await confirmModal(t('m3.confirmNewSeason'), { danger: true })) return;
    if (window.__seasonStarting) return;   /* anti-dublu-click */
    window.__seasonStarting = true;
    try {
    if (!isDemoMode()) {
        /* Atomic + idempotent: arhivă snapshot + reset puncte (DOAR acest club) +
           increment sezon, într-o singură tranzacție. Reflectăm local DOAR după
           succes, prin re-hidratare din DB (fără push optimist, fără upsert-uri
           secvențiale care lăsau stare inconsistentă la eșec parțial). */
        showNotification(t('m3.archivingSeason'), 'info');
        const res = await sb.rpc('start_new_season_atomic', { p_club_id: currentClubId });
        if (res.error) {
            logError('startNewSeason.rpc', res.error);
            showNotification(t('sb.errorColon') + res.error.message, 'error');
            return;  /* nimic schimbat local -> fără sezon „pe jumătate" */
        }
        await hydrateFromSupabase();  /* reîncarcă arhive + sezon + puncte (toate 0) din DB */
        render();
        if (typeof renderSeasonArchives === 'function') renderSeasonArchives();
        const _archived = res.data && res.data.archived;
        const _season = (res.data && res.data.season) != null ? res.data.season : state.currentSeason;
        /* Detaliile de audit trec prin i18n ca restul aplicației: un jurnal în
           română într-o interfață în engleză e o inconsecvență pe care o vede
           orice admin care comută limba. */
        addAuditLog('audit.newSeasonStarted', state.currentUser.name,
            { key: _archived ? 'auditd.seasonStarted' : 'auditd.seasonStartedAlready', params: { season: _season } });
        showNotification(t('m3.newSeasonDone'), 'success');
        return;
    }

    /* Demo: snapshot + reset local (fără DB). */
    const _msrcS = (state.membersById && Object.keys(state.membersById).length) ? state.membersById : (state.members || {});
    const standings = Object.values(_msrcS)
        .filter(m => m && !m.hidden)
        .map(m => ({ name: m.name || m.displayName || '', id: m.dbId || null, points: Number(m.score) || 0, games: m.gamesPlayed || 0 }))
        .sort((a, b) => b.points - a.points);
    const archive = { season: state.currentSeason, archivedAt: new Date().toISOString(), archivedBy: state.currentUser.name, standings };
    if (!Array.isArray(state.seasons)) state.seasons = [];
    state.seasons.push(archive);
    state.currentSeason = (parseInt(state.currentSeason) || new Date().getFullYear()) + 1;
    Object.keys(state.members).forEach(n => { if (state.members[n]) state.members[n].score = 0; });
    Object.values(state.membersById || {}).forEach(m => { if (m) m.score = 0; });
    render();
    if (typeof renderSeasonArchives === 'function') renderSeasonArchives();
    addAuditLog('audit.newSeasonStarted', state.currentUser.name,
        { key: 'auditd.seasonArchivedDemo', params: { season: archive.season, n: standings.length } });
    showNotification(t('m3.newSeasonDone'), 'success');
    } finally { window.__seasonStarting = false; }
}

async function setSeasonPeriod(m, y) {
    if (typeof requireWritableClub === 'function' && !requireWritableClub()) return;
    if (typeof can === 'function' ? !can('settings.edit') : !isAdmin) { showNotification(t('m3.onlyAdminPeriod'), 'error'); return; }
    m = Math.min(12, Math.max(1, parseInt(m) || 1));
    y = parseInt(y) || new Date().getFullYear();
    if (!isDemoMode()) {
        const a = await sb.from('club_settings').upsert({ club_id: currentClubId, key: 'current_month', value: m, updated_at: new Date().toISOString() }, { onConflict: 'club_id,key' });
        const b = await sb.from('club_settings').upsert({ club_id: currentClubId, key: 'current_year', value: y, updated_at: new Date().toISOString() }, { onConflict: 'club_id,key' });
        if ((a && a.error) || (b && b.error)) { showNotification(t('m3.periodSaveError'), 'error'); return; }
    }
    state.seasonMonth = m;
    state.seasonYear = y;
    renderDashboard();
    showNotification(t('m3.periodSet').replace('{m}', m).replace('{y}', y), 'success');
}
async function setSeasonLabel(label) {
    if (typeof requireWritableClub === 'function' && !requireWritableClub()) return;
    if (typeof can === 'function' ? !can('settings.edit') : !isAdmin) { showNotification(t('m3.onlyAdminLabel'), 'error'); return; }
    label = (label || '').toString().trim().slice(0, 40);
    if (!isDemoMode()) {
        const r = await sb.from('club_settings').upsert({ club_id: currentClubId, key: 'season_label', value: label, updated_at: new Date().toISOString() }, { onConflict: 'club_id,key' });
        if (r && r.error) { showNotification(t('m3.labelSaveError'), 'error'); return; }
    }
    state.seasonLabel = label;
    renderDashboard();
    const inp = document.getElementById('seasonLabelInput'); if (inp) inp.value = label;
    showNotification(label ? t('m3.labelSet').replace('{label}', label) : t('m3.labelReset'), 'success');
}

function renderSeasonArchives() {
    const box = document.getElementById('seasonArchives');
    if (!box) return;
    const esc = s => window.escHtml(s);
    const arr = Array.isArray(state.seasons) ? state.seasons.slice().reverse() : [];
    if (!arr.length) { box.innerHTML = '<p style="color:var(--text-secondary);">' + t('archives.none') + '</p>'; return; }
    box.innerHTML = arr.map(s => {
        const top = (s.standings || []).slice(0, 5).map((r, i) => `${i + 1}. ${esc(r.name)} — ${Number(r.points).toFixed(1)}p`).join('<br>');
        return `<div style="border:1px solid var(--border); border-radius:10px; padding:12px; margin-bottom:10px;">
            <strong>${t('archives.seasonWord')} ${esc(String(s.season))}</strong>
            <small style="color:var(--text-secondary);"> &middot; arhivat ${esc((s.archivedAt || '').split('T')[0])}${s.archivedBy ? ' de ' + esc(s.archivedBy) : ''}</small>
            <div style="margin-top:8px; font-size:.9em; line-height:1.7;">${top || t('common.noData')}</div>
        </div>`;
    }).join('');
}

function openSeasonArchives() {
    const esc = s => window.escHtml(s);
    const arr = Array.isArray(state.seasons) ? state.seasons.slice().reverse() : [];
    const body = arr.length ? arr.map(s => {
        const rows = (s.standings || []).slice(0, 10).map((r, i) => `${i + 1}. ${esc(r.name)} — ${Number(r.points).toFixed(1)}p`).join('<br>');
        const aid = esc(String(s.archivedAt || ''));
        return `<div style="border:1px solid var(--border); border-radius:10px; padding:12px; margin-bottom:10px;">
            <div style="display:flex; justify-content:space-between; align-items:center; gap:10px;">
              <strong>${t('archives.seasonWord')} ${esc(String(s.season))}</strong>
              <button class="btn-x-small" title="${t('archives.delFromArchive')}" onclick="deleteSeasonArchive('${aid}')"><i class="fas fa-trash"></i></button>
            </div>
            <small style="color:var(--text-secondary);">arhivat ${esc((s.archivedAt || '').split('T')[0])}${s.archivedBy ? ' de ' + esc(s.archivedBy) : ''}</small>
            <div style="margin-top:8px; font-size:.9em; line-height:1.7;">${rows || t('common.noData')}</div>
        </div>`;
    }).join('') : '<p style="color:var(--text-secondary);">' + t('archives.none') + '</p>';

    let modal = document.getElementById('seasonArchivesModal');
    if (!modal) {
        modal = document.createElement('div');
        modal.id = 'seasonArchivesModal';
        document.body.appendChild(modal);
    }
    modal.className = 'modal active';
    modal.innerHTML = `<div class="modal-content" style="max-width:560px;">
        <div class="modal-header">
          <h2><i class="fas fa-box-archive"></i> ${t('archives.title')}</h2>
          <button class="modal-close" onclick="document.getElementById('seasonArchivesModal').remove()">×</button>
        </div>
        <div style="max-height:60vh; overflow:auto;">${body}</div>
    </div>`;
}
async function deleteSeasonArchive(archivedAt) {
    if (!isAdmin) { showNotification(t('m3.onlyAdminArchiveDel'), 'error'); return; }
    if (!await confirmModal(t('m3.confirmDeleteSeasonArchive'), { danger: true })) return;
    state.seasons = (state.seasons || []).filter(s => String(s.archivedAt || '') !== String(archivedAt));
    if (!isDemoMode()) {
        const up = await sb.from('club_settings').upsert({ club_id: currentClubId, key: 'season_archives', value: state.seasons, updated_at: new Date().toISOString() }, { onConflict: 'club_id,key' });
        if (up.error) { showNotification(t('m2.deleteErrorColon') + up.error.message, 'error'); return; }
    }
    showNotification(t('m3.seasonDeletedArchive'), 'success');
    openSeasonArchives();
}

function generateSeasonReport() {
    const players = getSortedPlayers();
    const totalGames = state.games.length;
    const totalPoints = players.reduce((sum, p) => sum + p.score, 0);
    
    return {
        season: state.currentSeason,
        players: players.map(p => ({
            name: p.name,
            score: p.score,
            gamesPlayed: p.gamesPlayed,
            avgScore: p.gamesPlayed > 0 ? (p.score / p.gamesPlayed).toFixed(2) : '0.00',
            wins: countWins(p.dbId)
        })),
        totalGames,
        totalPoints,
        mostPlayedGame: getMostPlayedGame(),
        averageRating: getAverageRating(),
        generatedAt: new Date().toISOString()
    };
}

async function exportSeasonReport() {
    if (!requireFeature('export')) return;
    if (!isAdmin) {
        showNotification(t('m3.onlyAdminSeasonReport'), 'error');
        return;
    }
    /* Batch 2: librăria de PDF se aduce la cerere (nu mai e încărcată la pornire). */
    if (!await window.ensureLibOrWarn('jspdf')) return;
    try {
        const { jsPDF } = window.jspdf;
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.text(`Raport sezon ${state.currentSeason} — ${clubDisplayName()}`, 105, 16, { align: 'center' });
        doc.setFontSize(10);
        doc.text(`Generat: ${new Date().toLocaleString('en-GB')}`, 105, 23, { align: 'center' });

        const _msrcS = (state.membersById && Object.keys(state.membersById).length) ? state.membersById : (state.members || {});
        const standings = Object.values(_msrcS)
            .filter(m => m && !m.hidden)
            .map(m => ({ name: m.name || m.displayName || '', id: m.dbId || null, points: Number(m.score) || 0, games: m.gamesPlayed || 0 }))
            .sort((a, b) => b.points - a.points);
        const rows = standings.map((r, i) => [String(i + 1), r.name, r.points.toFixed(1), String(r.games)]);

        if (typeof doc.autoTable === 'function') {
            doc.autoTable({
                startY: 30,
                /* Antetul PDF trecea prin i18n nicăieri: raportul ieșea în română
               indiferent de limba interfeței. */
            head: [['#', t('stats.player'), t('stats.points'), t('stats.games')]],
                body: rows,
                styles: { fontSize: 10, cellPadding: 3, overflow: 'linebreak' },
                headStyles: { fillColor: [255, 107, 53] },
                alternateRowStyles: { fillColor: [245, 245, 245] },
                margin: { left: 14, right: 14 },
                rowPageBreak: 'auto'
            });
        } else {
            let y = 34; doc.setFontSize(10);
            rows.forEach(r => { if (y > 285) { doc.addPage(); y = 16; } doc.text(r.join('   '), 14, y); y += 7; });
        }

        doc.save(`turnorder-sezon-${state.currentSeason}-raport.pdf`);
        addAuditLog('audit.seasonReportPdf', state.currentUser.name);
        showNotification(t('m3.seasonReportPdf'), 'success');
    } catch (error) {
        console.error('Season PDF:', error);
        showNotification(t('m3.pdfGenError'), 'error');
    }
}

/* RO: `archiveSeason()` și `resetSeason()` au fost ELIMINATE. Motive:

     · `archiveSeason` era stricat de două ori. Scria în `state.seasons` + `saveState()`
       — care persistă local DOAR {settings, audit, lastSaved} — deci arhiva dispărea la
       primul refresh. Iar forma pusă (`{year, report, status}`) nu se potrivea cu ce
       citește `renderSeasonArchives` (`{season, standings, archivedBy}`), deci cât timp
       era în memorie s-ar fi afișat „Sezon undefined", fără clasament. Apăsai butonul,
       primeai „Sezon arhivat!", și nu se întâmpla nimic. Arhivarea REALĂ o face
       `start_new_season_atomic`, prin `startNewSeason()`.

     · `resetSeason` era cod mort — niciun buton n-o apela — și periculos: golea
       `state.games`, punctele, statisticile din catalog, poll-urile și evenimentele,
       tot în memorie. Legată din greșeală, ar fi arătat utilizatorului tot istoricul
       clubului dispărând, apoi revenind la refresh.

   Cheile i18n rămase fără utilizare au fost șterse: `m3.onlyAdminArchiveSeasons`,
   `m3.confirmArchiveSeason`, `m3.seasonArchived`, `m3.onlyAdminResetSeasons`,
   `m3.confirmResetSeason`, `m3.seasonResetDone`, `audit.seasonArchived`,
   `audit.seasonFullReset`, `admin.archiveSeason`, `admin.resetSeason`.
   EN: both removed — one wrote to memory only and in the wrong shape, the other was
       unreachable dead code that would have appeared to wipe the club's history. */


async function fullReset() {
    /* GARDĂ (Etapa 2d): `isAdmin` este flag-ul LEGACY și e `true` și pentru Admin
       secundar (vezi `applyClubRole`), deci un admin secundar putea reseta datele
       clubului. Resetarea e o operațiune de nivel proprietar => `club.delete`
       (rang 4 = Admin principal). Clientul e doar UX; blocarea reală trebuie să
       stea în politicile RLS ale tabelelor șterse mai jos.
       EN: `isAdmin` is the legacy flag and is also true for secondary admins.
       Club data reset is an owner-level operation => `club.delete` (rank 4). */
    if (typeof can === 'function' ? !can('club.delete') : !isAdmin) {
        showNotification((typeof t === 'function' ? t('rbac.noPermission') : 'Nu ai permisiunea pentru această acțiune.'), 'error');
        return;
    }
    /* v9 H25: resetarea scrie în club, deci intră sub garda §21.5. Fără ea, după garda de pe
       server pentru chat, o resetare într-un club doar-citire ar șterge sesiunile și
       evenimentele, dar nu și chatul (rezultat pe jumătate).
       EN: reset writes club data (§21.5); without the guard a read-only club would be half-reset. */
    if (typeof requireWritableClub === 'function' && !requireWritableClub()) return;

    if (!await confirmModal(t('admin.clubResetC1'), { danger: true })) return;
    /* A DOUA confirmare e acum parola, nu un al doilea „ești sigur?". Două ferestre
       identice se apasă amândouă din reflex; parola cere ceva ce doar proprietarul
       contului are. Același strat ca la ban / transfer de proprietate. */
    if (typeof requireReauth === 'function' && !await requireReauth('club.reset')) return;

    const clubId = (typeof currentClubId !== 'undefined') ? currentClubId : null;
    const demo = (typeof isDemoMode === 'function') ? isDemoMode() : false;

    // --- Ștergeri în Supabase, STRICT scope-uite pe clubul curent ---
    if (!demo && typeof sb !== 'undefined' && sb && clubId) {
        try {
            const dM = await sb.from('matches').delete().eq('club_id', clubId);
            if (dM.error) showNotification(t('m3.sessionsErrorColon') + dM.error.message, 'error');
            const dE = await sb.from('events').delete().eq('club_id', clubId);
            if (dE.error) showNotification(t('m3.eventsErrorColon') + dE.error.message, 'error');
            /* v9 B3: mesajele prin funcția serverului (după B3b nu mai există ștergere
               directă) ⇒ 8.13-3: ștearsă și calea veche. EN: server RPC only. */
            const dMsg = await sb.rpc('clear_club_chat', { p_club: clubId });
            if (dMsg.error) showNotification(t('m3.chatErrorColon') + dMsg.error.message, 'error');
            // NOTĂ: scorurile acumulate de jucători (profiles.points) NU se ating —
            // sunt punctele lor, dispar doar din clubul curent prin ștergerea sesiunilor.
        } catch (e) {
            showNotification(t('m3.resetErrorColon') + (e && e.message ? e.message : e), 'error');
        }
    }

    // --- Reset în state local (doar datele clubului curent) ---
    state.games = [];
    state.events = [];
    state.polls = [];
    state.chatMessages = [];
    // Scorurile/gamesPlayed ale membrilor rămân — sunt acumulate de jucători.
    Object.keys(state.catalog || {}).forEach(g => {
        if (state.catalog[g]) {
            state.catalog[g].timesPlayed = 0;
            state.catalog[g].lastPlayed = null;
            state.catalog[g].actualDurations = [];
            state.catalog[g].avgDuration = null;
        }
    });

    if (typeof saveState === 'function') saveState();

    // --- Re-render ---
    if (typeof renderDashboard === 'function') renderDashboard();
    if (typeof renderPlayers === 'function') renderPlayers();
    if (typeof renderHistory === 'function') renderHistory();
    if (typeof renderCatalog === 'function') renderCatalog();
    if (window.TO_CHAT && window.TO_CHAT.readyModule && window.TO_CHAT.readyModule('TO_POLLS')) renderPolls();   /* 8.16-3d: polls.js la cerere */
    if (typeof renderCalendar === 'function') renderCalendar();
    if (typeof renderAdmin === 'function') renderAdmin();

    if (typeof addAuditLog === 'function') {
        try { addAuditLog('audit.clubDataReset', state.currentUser ? state.currentUser.name : 'SYSTEM'); } catch (e) { logError('fullReset', e); }
    }
    showNotification(t('admin.clubResetDone'), 'success');
}

/* ================= HISTORY ================= */
let historyPage = 1;
let historyExpanded = false;
function historyFilterChanged() { historyPage = 1; historyExpanded = false; renderHistory(); }
function renderHistory() {
    const container = document.getElementById('historyList');
    const filterPlayer = document.getElementById('historyFilterPlayer').value;
    const filterPeriod = document.getElementById('historyFilterPeriod').value;
    const filterGame = document.getElementById('historyFilterGame').value;
    const filterSearch = (document.getElementById('historySearch') ? document.getElementById('historySearch').value : '').trim().toLowerCase();
    
    // Populate filters
    populateHistoryFilters();
    
    // Filter games
    let filteredGames = state.games;
    
    // Filter by player
    if (filterPlayer) {
        filteredGames = filteredGames.filter(game => 
            game.participants?.includes(filterPlayer) || 
            game.scores?.[filterPlayer] !== undefined
        );
    }
    
    // Filter by period
    if (filterPeriod && filterPeriod !== 'all') {
        const now = new Date();
        let startDate;
        
        switch(filterPeriod) {
            /* Vezi nota din calculatePeriodStats: `now.setX()` muta originalul și
               `setMonth` aluneca în zilele de 29–31. */
            case 'week':
                startDate = addDays(now, -7);
                break;
            case 'month':
                startDate = addMonths(now, -1);
                break;
            case 'year':
                startDate = addYears(now, -1);
                break;
            case 'last30':
                startDate = addDays(now, -30);
                break;
        }
        
        filteredGames = filteredGames.filter(game => 
            new Date(game.timestamp) >= startDate
        );
    }
    
    // Filter by game
    if (filterGame) {
        filteredGames = filteredGames.filter(game => 
            game.gameName === filterGame
        );
    }

    // Filter by keyword (joc, jucători, locație, notițe, înregistrat de)
    if (filterSearch) {
        const nm = id => (typeof displayNameById === 'function' && displayNameById(id)) || id;
        filteredGames = filteredGames.filter(game => {
            const players = (Array.isArray(game.participants) ? game.participants : Object.keys(game.participants || {})).map(nm);
            const hay = [game.gameName, game.location, game.notes, nm(game.recordedBy)].concat(players)
                .filter(Boolean).join(' ').toLowerCase();
            return hay.includes(filterSearch);
        });
    }
    
    // Sort by date (newest first)
    filteredGames.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    
    if (filteredGames.length === 0) {
        container.innerHTML = `
            <div class="card" style="text-align: center; padding: 40px;">
                <h3><i class="fas fa-history"></i> ${t('hist.noSessions')}</h3>
                <p style="color: var(--text-secondary); margin-top: 10px;">
                    ${filterPlayer || filterPeriod !== 'all' || filterGame ? 
                        t('hist.tryOtherFilters') : 
                        t('hist.startFirst')}
                </p>
            </div>
        `;
        return;
    }
    
    // Afișare cu „Vezi mai mult" după 10 sesiuni (pagină mai scurtă)
    const HIST_LIMIT = 10;
    const histExpanded = !!historyExpanded;
    const shownGames = histExpanded ? filteredGames : filteredGames.slice(0, HIST_LIMIT);

    container.innerHTML = shownGames.map(game => renderHistoryCard(game)).join('');

    const pag = document.getElementById('historyPagination');
    if (pag) {
        if (filteredGames.length <= HIST_LIMIT) {
            pag.innerHTML = '';
        } else if (histExpanded) {
            pag.innerHTML = '<button type="button" class="btn btn-sm btn-secondary players-more-btn" data-hist-act="expand"><i class="fas fa-chevron-up"></i> ' + t('players.showLess') + '</button>';
        } else {
            pag.innerHTML = '<button type="button" class="btn btn-sm btn-secondary players-more-btn" data-hist-act="expand"><i class="fas fa-chevron-down"></i> ' + t('players.showMore') + ' (' + (filteredGames.length - HIST_LIMIT) + ')</button>';
        }
    }
}

function toggleHistoryExpanded() {
    historyExpanded = !historyExpanded;
    if (typeof renderHistory === 'function') renderHistory();
    /* Faza 2: la „vezi tot”, dacă istoricul e încă parțial, îl completăm și re-randăm
       când sosește (fundalul îl aducea oricum; aici forțăm ca expandarea să arate TOT). */
    if (historyExpanded && state._gamesPartial && typeof ensureFullHistory === 'function') {
        ensureFullHistory().then(() => { try { renderHistory(); } catch (e) { logError('toggleHistoryExpanded', e); } });
    }
}

/* Colapsare jucători per sesiune (primii 3 + „vezi toți") */
function toggleHistPlayers(btn) {
    var card = btn.closest('.history-card');
    var box = card ? card.querySelector('.hist-scores') : null;
    if (!box) return;
    box.classList.toggle('collapsed');
    var total = box.querySelectorAll('.hist-score-row').length;
    if (box.classList.contains('collapsed')) {
        btn.innerHTML = '<i class="fas fa-chevron-down"></i> ' + t('hist.seeAllPlayers') + ' (' + total + ')';
    } else {
        btn.innerHTML = '<i class="fas fa-chevron-up"></i> ' + t('players.showLess');
    }
}

/* v9 8.16-4h (2 nov. 2026): ISTORICUL fără handlere inline (erau 17: căutarea, filtrele, exportul, „Vezi mai
   mult", jucătorii, pozele, Distribuie / Editează / Șterge). O singură delegare pe `document`, pe faza de
   CAPTURĂ (lista se redesenează), legată o dată; fiecare acțiune cheamă ACEEAȘI funcție, cu aceleași
   argumente, ca vechiul `onclick`. Id-ul partidei și adresa pozei sunt DATE (`data-sid`, `data-gal`),
   nu cod. `data-sid` e și legătura stabilă spre o partidă („Deschide" de pe cardul din chat).
   Câmpurile: căutarea pe `input`, listele pe `change` — exact evenimentele de dinainte.
   EN: history without inline handlers; one capture-phase delegation; same calls, ids travel as data. */
(function () {
    if (document.__toHistActs) return;
    document.__toHistActs = true;
    document.addEventListener('click', function (e) {
        const el = e.target && e.target.closest ? e.target.closest('[data-hist-act]') : null;
        if (!el) return;
        const a = el.getAttribute('data-hist-act');
        const card = el.closest('.history-card'), sid = card ? card.getAttribute('data-sid') : null;
        switch (a) {
            case 'tile': toggleTilePanel(el.getAttribute('data-panel'), el); break;
            case 'clear': clearHistoryFilters(); break;
            case 'csv': exportHistoryCSV(); break;
            case 'pdf': exportHistoryPDF(); break;
            case 'expand': toggleHistoryExpanded(); break;
            case 'players': toggleHistPlayers(el); break;
            case 'photo': if (typeof openLightbox === 'function') openLightbox(el.getAttribute('data-gal'), { type: 'photo', id: sid, clubId: currentClubId }, el); break;
            case 'share': if (sid != null && typeof openShareMenu === 'function') openShareMenu('session', sid, el); break;
            case 'edit': if (sid != null) editSession(sid); break;
            case 'delete': if (sid != null) deleteSession(sid); break;
        }
    }, true);
    document.addEventListener('input', function (e) {
        const el = e.target;
        if (el && el.tagName === 'INPUT' && el.getAttribute('data-hist-act') === 'filter') historyFilterChanged();
    }, true);
    document.addEventListener('change', function (e) {
        const el = e.target;
        if (el && el.tagName === 'SELECT' && el.getAttribute('data-hist-act') === 'filter') historyFilterChanged();
    }, true);
})();

function populateHistoryFilters() {
    // Populate player filter
    const playerFilter = document.getElementById('historyFilterPlayer');
    const currentPlayerValue = playerFilter.value;
    
    playerFilter.innerHTML = '<option value="">' + t('hist.allPlayers') + '</option>';
    getSortedPlayers().forEach(player => {
        const option = document.createElement('option');
        option.value = player.dbId || player.name;
        option.textContent = player.name;
        playerFilter.appendChild(option);
    });
    
    // Restore selected value
    if (currentPlayerValue) {
        playerFilter.value = currentPlayerValue;
    }
    
    // Populate game filter
    const gameFilter = document.getElementById('historyFilterGame');
    const currentGameValue = gameFilter.value;
    
    gameFilter.innerHTML = '<option value="">' + t('session.allGames') + '</option>';
    Object.keys(state.catalog).sort().forEach(gameName => {
        const option = document.createElement('option');
        option.value = gameName;
        option.textContent = gameName;
        gameFilter.appendChild(option);
    });
    
    // Restore selected value
    if (currentGameValue) {
        gameFilter.value = currentGameValue;
    }
}

function fmtSecs(s) {
    s = Math.max(0, Math.round(s));
    const m = Math.floor(s / 60), ss = s % 60, h = Math.floor(m / 60), mm = m % 60;
    return (h > 0 ? h + 'h ' : '') + (mm > 0 || h > 0 ? mm + 'm ' : '') + ss + 's';
}

function renderSessionMetaDetails(game) {
    let html = '';
    const nm = id => (typeof displayNameById === 'function' && displayNameById(id)) || id;
    if (game.roles && typeof game.roles === 'object' && Object.keys(game.roles).length) {
        html += `<div style="margin-top:12px; padding:10px; background:var(--bg-card); border-radius:8px;">
            <div style="color:var(--text-secondary); font-weight:600; margin-bottom:6px;"><i class="fas fa-masks-theater"></i> ${t('roles.heading')}</div>
            ${Object.keys(game.roles).map(p => `<div style="display:flex; justify-content:space-between; font-size:0.9em;"><span>${clubEsc(nm(p))}</span><span style="opacity:0.85;">🎭 ${clubEsc(game.roles[p])}</span></div>`).join('')}
        </div>`;
    }
    if (game.playerTimes && typeof game.playerTimes === 'object' && Object.keys(game.playerTimes).length) {
        const entries = Object.keys(game.playerTimes).map(p => [p, game.playerTimes[p]]).sort((a, b) => b[1] - a[1]);
        html += `<div style="margin-top:12px; padding:10px; background:var(--bg-card); border-radius:8px;">
            <div style="color:var(--text-secondary); font-weight:600; margin-bottom:6px;"><i class="fas fa-clock"></i> ${t('hist.turnTime')}</div>
            ${entries.map(e => `<div style="display:flex; justify-content:space-between; font-size:0.9em;"><span>${clubEsc(nm(e[0]))}</span><span style="opacity:0.85;">${fmtSecs(e[1])}</span></div>`).join('')}
        </div>`;
    }
    if (game.scoresheet && game.scoresheet.fields && game.scoresheet.breakdown) {
        const fields = game.scoresheet.fields, bd = game.scoresheet.breakdown, players = Object.keys(bd);
        if (players.length) {
            html += `<details style="margin-top:12px;"><summary style="cursor:pointer; color:var(--text-secondary); font-weight:600;"><i class="fas fa-table-list"></i> Detaliere scoruri</summary>
                <div class="table-responsive" style="margin-top:8px;"><table>
                <thead><tr><th style="text-align:left;">${t('stats.player')}</th>${fields.map(f => `<th>${clubEsc(f)}</th>`).join('')}<th>${t('common.total')}</th></tr></thead>
                <tbody>${players.map(p => { const row = bd[p] || {}; const tot = fields.reduce((s, f) => s + (Number(row[f]) || 0), 0); return `<tr><td style="text-align:left;">${clubEsc(nm(p))}</td>${fields.map(f => `<td>${Number(row[f]) || 0}</td>`).join('')}<td><strong>${tot}</strong></td></tr>`; }).join('')}</tbody>
                </table></div></details>`;
        }
    }
    return html;
}

function renderHistoryCard(game) {
    const nm = id => (typeof displayNameById === 'function' && displayNameById(id)) || id;
    const date = new Date(game.timestamp);
    const dateStr = date.toLocaleDateString('en-GB');
    const timeStr = date.toLocaleTimeString(appTimeLocale(), { hour: '2-digit', minute: '2-digit' });
    const locationStr = game.location ? ` • ${window.escHtml(game.location)}` : '';
    const isCoop = game.type === 'coop' || !!game.coop;
    const isCampaign = game.scoreKind === 'campaign';
    const coopWin = isCoop && game.coop && game.coop.outcome === 'win';
    const typeBadge = game.isTournament ?
        '<span class="badge badge-warning" style="margin-left: 10px;"><i class="fas fa-trophy"></i> Turneu</span>' :
        (isCoop ? `<span class="badge" style="margin-left:10px; background:${coopWin ? 'var(--success,#27ae60)' : '#b23b3b'}; color:#fff;"><i class="fas fa-people-group"></i> ${t('hist.coop')} — ${coopWin ? t('camp.win') : t('camp.loss')}</span>`
        : (isCampaign ? `<span class="badge" style="margin-left:10px; background:#6c5ce7; color:#fff;"><i class="fas fa-dragon"></i> ${t('hist.campaign')}</span>` : ''));
    const friendlyBadge = game.friendly ?
        `<span class="badge" style="margin-left:10px; background:var(--accent-primary,#ff6b35); color:#fff;"><i class="fas fa-handshake"></i> ${t('hist.friendly')}</span>` : '';
    /* Flag sesiune uniformizată (§18): scorurile brute au fost convertite în
       Puncte de Club. Badge distinct + tooltip explicativ. */
    const isUniform = game.scoreMode === 'uniform';
    /* Coop uniform: toți primesc aceleași Puncte de Club (Șablonul B). Valoarea comună. */
    const coopPtsEach = (isCoop && isUniform && game.clubPoints)
        ? (() => { const v = (game.participants || []).map(p => game.clubPoints[p]).find(x => x != null); return v != null ? Number(v) : null; })()
        : null;
    const uniformBadge = isUniform ?
        (typeof uniformBadgeHtml === 'function' ? uniformBadgeHtml() : '') : '';
    /* Câștigător(i) de tie-break (§18 — departajare manuală la egalitate):
       simbol khanda — ACELAȘI folosit în UI-ul de stabilire a departajării
       (renderTieBreakBar), ca să nu existe confuzie cu trofeul de turneu. */
    const _tbWon = pid => !!(game.tieBreaks && game.tieBreaks[pid]);
    const tieIcon = pid => _tbWon(pid)
        ? ` <i class="fas fa-khanda" style="color:var(--accent-gold,#f9a826);" title="${t('hist.tieBreakWon')}"></i>` : '';
    /* Punctele de Club atribuite fiecărui jucător, mic în paranteză (doar la
       uniform ne-campanie — la campania uniformă valoarea principală ESTE deja
       în Puncte de Club, nu dublăm). */
    const cpNote = pid => (isUniform && !isCampaign && game.clubPoints && game.clubPoints[pid] != null)
        ? ` <small style="opacity:.65; font-weight:400;">(${(Number(game.clubPoints[pid]) || 0)} ${t('hist.clubPts')})</small>` : '';

    // Get scores sorted (la egalitate, câștigătorul tie-break-ului urcă pentru medalie).
    // La campania uniformizată afișăm Punctele de Club (participare + bonus), nu brutul.
    const _wIds = isCampaign ? [] : (Array.isArray(game.winners) ? game.winners.filter(Boolean) : []);
    const _isW = id => (_wIds.indexOf(id) !== -1 ? 1 : 0);
    const _dispObj = (game.scoreMode === 'uniform' && isCampaign && game.clubPoints) ? game.clubPoints : (game.scores || {});
    const scores = Object.entries(_dispObj);
    const sortedScores = scores.sort((a, b) => (b[1] - a[1]) || (_isW(b[0]) - _isW(a[0])));
    let winner = null;
    if (_wIds.length) {
        const _wid = _wIds[0];
        winner = [_wid, (_dispObj[_wid] != null ? _dispObj[_wid] : 0)];
    } else if (!isCampaign) {
        winner = sortedScores.length > 0 ? sortedScores[0] : null;
    }
    
    return `
        <div class="history-card" data-sid="${window.escHtml(String(game.id))}" style="
            background: var(--bg-secondary);
            padding: 20px;
            margin-bottom: 20px;
            border-radius: 10px;
            border-left: 4px solid ${game.isTournament ? 'var(--accent-gold)' : 'var(--accent-primary)'};
        ">
            <div class="hist-head" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
                <div style="min-width:0;">
                    <h3 style="color: var(--accent-gold); margin: 0;">${window.escHtml(game.gameName || 'Sesiune')}</h3>
                    <div style="color: var(--text-secondary); margin-top: 5px;">
                        <i class="fas fa-calendar"></i> ${dateStr} ${timeStr}${locationStr}
                        ${typeBadge}${friendlyBadge}${uniformBadge}
                    </div>
                </div>
                ${(!isCoop && winner) ? `
                    <div class="hist-winner" style="text-align: right;">
                        <div style="color: var(--success); font-weight: bold;">
                            <i class="fas fa-crown"></i> ${window.escHtml(nm(winner[0]))}${tieIcon(winner[0])}
                        </div>
                        <div style="color: var(--text-secondary); font-size: 0.9em;">
                            ${(Number(winner[1]) || 0).toFixed(1)} ${t('hist.points')}
                        </div>
                    </div>
                ` : ''}
            </div>
            
            <div class="game-scores" style="margin-top: 15px;">
                ${isCoop ? `
                    <div style="padding:10px; background:var(--bg-primary); border-radius:8px;">
                        <div style="font-weight:700; color:${coopWin ? 'var(--success,#27ae60)' : '#e07a5f'};">
                            <i class="fas fa-flag-checkered"></i> ${coopWin ? t('hist.teamWin') : t('camp.loss')}
                            ${(game.coop && game.coop.teamScore != null) ? ` • ${t('hist.teamScore')}: ${game.coop.teamScore}` : ''}
                            ${coopPtsEach != null ? ` • ${coopPtsEach} ${t('hist.clubPts')} ${t('coop.ptsEachSuffix')}` : ''}
                        </div>
                        ${(() => {
                            const _c = game.coop || {};
                            const _dtxt = (typeof coopDifficultyText === 'function') ? coopDifficultyText(_c) : (_c.difficulty || '');
                            const _meta = [];
                            if (_dtxt) _meta.push('🏔 ' + t('coop.difficultyShort') + ': ' + clubEsc(_dtxt));
                            if (_c.detail) _meta.push('🎯 ' + t('coop.detailShort') + ': ' + clubEsc(String(_c.detail)));
                            return _meta.length ? `<div style="font-size:0.85em; opacity:0.85; margin-top:4px; display:flex; flex-wrap:wrap; gap:4px 14px;">${_meta.map(m => `<span>${m}</span>`).join('')}</div>` : '';
                        })()}
                        ${(game.coop && game.coop.scenario) ? `<div style="font-size:0.85em; opacity:0.8; margin-top:4px;"><i class="fas fa-book"></i> ${clubEsc(game.coop.scenario)}</div>` : ''}
                        ${(game.coop && (game.coop.mvp || game.coop.mvpCustom)) ? `<div style="font-size:0.85em; margin-top:4px; color:var(--accent-gold,#f9a826);"><i class="fas fa-medal"></i> ${t('coop.mvpShort')}: ${clubEsc(game.coop.mvpCustom || nm(game.coop.mvp))}</div>` : ''}
                        <div style="font-size:0.85em; opacity:0.8; margin-top:6px;"><i class="fas fa-users"></i> ${(game.participants || []).map(p => clubEsc(nm(p))).join(', ')}</div>
                    </div>
                ` : `
                    <div class="hist-scores${sortedScores.length > 3 ? ' collapsed' : ''}">
                    ${sortedScores.map(([player, score], index) => {
                    const medal = index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : '';
                    return `
                        <div class="hist-score-row" style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 8px;
                            margin: 4px 0;
                            background: var(--bg-primary);
                            border-radius: 8px;
                        ">
                            <div class="hist-score-name">
                                ${medal} ${window.escHtml(nm(player))}${tieIcon(player)}
                            </div>
                            <div class="hist-score-pts" style="font-weight: bold; color: var(--accent-primary);">
                                ${(Number(score) || 0).toFixed(1)} ${t('hist.points')}${cpNote(player)}
                            </div>
                        </div>
                    `;
                    }).join('')}
                    </div>
                    ${sortedScores.length > 3 ? `<button type="button" class="btn btn-sm btn-secondary hist-more-players" data-hist-act="players"><i class="fas fa-chevron-down"></i> ${t('hist.seeAllPlayers')} (${sortedScores.length})</button>` : ''}
                `}
                
                ${game.guests?.length > 0 ? `
                    <div style="margin-top: 10px; padding-top: 10px; border-top: 1px solid var(--border);">
                        <small style="color: var(--text-secondary);">
                            <i class="fas fa-user-plus"></i> ${t('hist.guests')}: ${game.guests.map(g => window.escHtml(g.name)).join(', ')}
                        </small>
                    </div>
                ` : ''}
            </div>
            
            ${game.notes ? `
                <div style="margin-top: 15px; padding: 10px; background: var(--bg-card); border-radius: 8px;">
                    <div style="color: var(--text-secondary); font-style: italic;">
                        <i class="fas fa-sticky-note"></i> ${window.escHtml(game.notes)}
                    </div>
                </div>
            ` : ''}
            
            ${(game.photos && game.photos.length) ? `
                <div style="margin-top: 15px;">
                    <small style="color: var(--text-secondary);"><i class="fas fa-camera-retro"></i> ${t('session.photos')}</small>
                    <div style="display:flex; flex-wrap:wrap; gap:8px; margin-top:8px;">
                        ${game.photos.map(u => `<img data-sp="${clubEsc(u)}" data-spt="1" data-gal="${clubEsc(u)}" src="${(window._SP_PH||'')}" loading="lazy" data-hist-act="photo" style="width:84px; height:84px; object-fit:cover; border-radius:8px; cursor:zoom-in;">`).join('')}
                    </div>
                </div>
            ` : ''}

            ${renderSessionMetaDetails(game)}
            
            <div class="hist-foot" style="display: flex; justify-content: space-between; margin-top: 15px; color: var(--text-secondary); font-size: 0.9em;">
                <div>
                    <i class="fas fa-users"></i> ${game.participants?.length || 0} ${t('hist.participants')}
                    • <i class="fas fa-clock"></i> ${game.duration || 'N/A'} min
                </div>
                <div>
                    <i class="fas fa-user"></i> ${t('history.recordedBy')} ${window.escHtml(nm(game.recordedBy))}
                </div>
            </div>
            
            <div class="btn-group hist-actions" style="margin-top: 15px;">
                <button class="btn btn-sm btn-secondary" title="${t('common.share')}" data-hist-act="share" style="width:auto; min-width:auto; padding:8px 12px;">
                    <i class="fas fa-share-nodes"></i> <span class="hist-btn-label">${t('common.share')}</span>
                </button>
                ${(typeof can === 'function' && can('match.edit')) ? `
                    <button class="btn btn-sm btn-secondary" title="${t('history.edit')}" data-hist-act="edit" style="width:auto; min-width:auto; padding:8px 12px;">
                        <i class="fas fa-edit"></i> <span class="hist-btn-label">${t('history.edit')}</span>
                    </button>` : ''}
                ${(typeof can === 'function' && can('match.delete')) ? `
                    <button class="btn btn-sm btn-danger" title="${t('common.delete')}" data-hist-act="delete" style="width:auto; min-width:auto; padding:8px 12px;">
                        <i class="fas fa-trash"></i> <span class="hist-btn-label">${t('common.delete')}</span>
                    </button>` : ''}
            </div>
        </div>
    `;
}

function goToHistoryPage(page) {
    historyPage = page;
    renderHistory();
    const el = document.getElementById('historyList');
    if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function clearHistoryFilters() {
    document.getElementById('historyFilterPlayer').value = '';
    document.getElementById('historyFilterPeriod').value = 'all';
    document.getElementById('historyFilterGame').value = '';
    const s = document.getElementById('historySearch'); if (s) s.value = '';
    historyPage = 1;
    renderHistory();
}

function exportHistoryCSV() {
    if (!requireFeature('export')) return;
    if (state.games.length === 0) {
        showNotification(t('m3.noHistoryExport'), 'error');
        return;
    }
    
    const headers = [t('csv.date'), t('csv.time'), t('stats.game'), t('event.location'), t('csv.type'), t('csv.duration'), t('csv.participants'), t('csv.winner'), t('csv.winnerScore'), t('common.notes')];
    const rows = state.games.map(game => {
        const date = new Date(game.timestamp);
        const dateStr = date.toLocaleDateString('en-GB');
        const timeStr = date.toLocaleTimeString(appTimeLocale(), { hour: '2-digit', minute: '2-digit' });
        const scores = game.scores ? Object.entries(game.scores) : [];
        const sortedScores = scores.sort((a, b) => (Number(b[1]) || 0) - (Number(a[1]) || 0));
        const winner = sortedScores.length > 0 ? sortedScores[0] : ['N/A', 0];
        const _nm = id => (typeof displayNameById === 'function' && displayNameById(id)) || id;
        const participants = (game.participants || []).map(_nm).join('; ') || '';
        const typeStr = game.type === 'coop' ? 'Co-op' : (game.isTournament ? t('session.tournament') : t('csv.typeNormal'));
        
        return [
            dateStr,
            timeStr,
            game.gameName || 'N/A',
            game.location || '',
            typeStr,
            game.duration || 'N/A',
            participants,
            _nm(winner[0]),
            (Number(winner[1]) || 0).toFixed(1),
            game.notes || ''
        ];
    });
    
    csvDownload(`turnorder-istoric-${new Date().toISOString().split('T')[0]}.csv`, headers, rows);
    
    addAuditLog('audit.exportHistoryCsv', state.currentUser.name);
    showNotification(t('m3.historyExported'), 'success');
}

async function exportHistoryPDF() {
    if (!requireFeature('export')) return;
    if (!state.games || state.games.length === 0) {
        showNotification(t('m3.noHistoryExport'), 'error');
        return;
    }
    /* Batch 2: librăria de PDF se aduce la cerere (nu mai e încărcată la pornire). */
    if (!await window.ensureLibOrWarn('jspdf')) return;
    try {
        const { jsPDF } = window.jspdf;
        const doc = new jsPDF();

        doc.setFontSize(18);
        doc.text(_pdfSafe(t('pdf.historyTitle') + ' ' + clubDisplayName()), 105, 16, { align: 'center' });
        doc.setFontSize(10);
        doc.text(_pdfSafe(`${t('pdf.generated')}: ${new Date().toLocaleString('en-GB')} • ${state.games.length} ${t('hist.sessions')}`), 105, 23, { align: 'center' });

        const rows = state.games
            .slice()
            .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
            .map(game => {
                const date = new Date(game.timestamp);
                const scores = game.scores ? Object.entries(game.scores) : [];
                const sorted = scores.sort((a, b) => (Number(b[1]) || 0) - (Number(a[1]) || 0));
                const _nmPdf = id => (typeof displayNameById === 'function' && displayNameById(id)) || id;
                const winner = sorted.length ? `${_nmPdf(sorted[0][0])} (${(Number(sorted[0][1]) || 0).toFixed(1)})` : '-';
                const pCount = Array.isArray(game.participants) ? game.participants.length : Object.keys(game.participants || {}).length;
                const typeStr = game.type === 'coop' ? 'Co-op' : (game.isTournament ? t('session.tournament') : t('csv.typeNormal'));
                return [
                    date.toLocaleDateString('en-GB'),
                    _pdfSafe(game.gameName || 'N/A'),
                    _pdfSafe(game.location || '-'),
                    _pdfSafe(typeStr),
                    pCount.toString(),
                    _pdfSafe(winner)
                ];
            });

        if (typeof doc.autoTable === 'function') {
            doc.autoTable({
                startY: 30,
                head: [[t('csv.date'), t('stats.game'), t('event.location'), t('csv.type'), t('stats.players'), t('csv.winner')].map(_pdfSafe)],
                body: rows,
                styles: { fontSize: 9, cellPadding: 2, overflow: 'linebreak' },
                headStyles: { fillColor: [255, 107, 53] },
                alternateRowStyles: { fillColor: [245, 245, 245] },
                margin: { left: 14, right: 14 },
                tableWidth: 'auto',
                rowPageBreak: 'auto'
            });
        } else {
            // Fallback if autoTable plugin failed to load
            let y = 34;
            doc.setFontSize(9);
            rows.forEach(r => {
                if (y > 285) { doc.addPage(); y = 16; }
                doc.text(r.join('  |  ').substring(0, 110), 12, y);
                y += 6;
            });
        }

        doc.save(`turnorder-istoric-${new Date().toISOString().split('T')[0]}.pdf`);
        if (state.currentUser) addAuditLog('audit.exportHistoryPdf', state.currentUser.name);
        showNotification(t('m3.historyPdf'), 'success');
    } catch (error) {
        console.error('Error generating history PDF:', error);
        showNotification(t('m3.pdfGenError'), 'error');
    }
}

/* ===== Tie-break în modalul de editare (oglindă a renderTieBreakBar din formular) =====
   Apare DOAR la sesiuni competitive uniformizate cu scoruri brute egale. Recalcul live. */
let _editTieBreaks = {};
function readEditScoresLive() {
    const out = {};
    const modal = document.querySelector('.modal.active[data-session-id]') || document.querySelector('.modal.active');
    if (!modal) return out;
    modal.querySelectorAll('input[id^="edit-score-"]').forEach(input => {
        const pid = input.dataset.player;
        if (pid) out[pid] = parseFloat(input.value) || 0;
    });
    return out;
}
function renderEditTieBreakBar() {
    const bar = document.getElementById('editTieBreakBar');
    if (!bar) return;
    const scores = readEditScoresLive();
    const ties = (typeof detectScoreTies === 'function') ? detectScoreTies(Object.keys(scores), scores) : [];
    const tiedSet = {}; ties.forEach(g => g.forEach(p => { tiedSet[p] = 1; }));
    Object.keys(_editTieBreaks).forEach(k => { if (!tiedSet[k]) delete _editTieBreaks[k]; });
    if (!ties.length) { bar.innerHTML = ''; return; }
    const nm = id => (typeof displayNameById === 'function' && displayNameById(id)) || id;
    bar.innerHTML = `
        <div style="border:1px solid var(--accent-gold,#ffd700); background:rgba(255,215,0,0.06); border-radius:10px; padding:12px; margin:8px 0 14px;">
            <div style="font-weight:700; display:flex; align-items:center; gap:8px;"><i class="fas fa-khanda" style="color:var(--accent-gold,#ffd700);"></i> ${t('session.tieBreakTitle')}</div>
            <small style="color:var(--text-secondary); display:block; margin:4px 0 10px;">${t('session.tieBreakHint')}</small>
            ${ties.map(group => {
                const sc = scores[group[0]];
                return `<div style="margin-top:8px;">
                    <div style="font-size:0.82em; color:var(--text-secondary); margin-bottom:6px;">${t('session.tieAt')} <strong>${sc}</strong> ${t('hist.points')}</div>
                    <div style="display:flex; flex-wrap:wrap; gap:8px;">
                        ${group.map(pid => {
                            const on = !!_editTieBreaks[pid];
                            return `<button type="button" class="btn btn-sm ${on ? 'btn-primary' : 'btn-secondary'}" style="width:auto; flex:none;" onclick="toggleEditTieBreak('${window.attrJs(pid)}')"><i class="fas fa-${on ? 'trophy' : 'khanda'}"></i> ${window.escHtml(nm(pid))}</button>`;
                        }).join('')}
                    </div>
                </div>`;
            }).join('')}
        </div>`;
}
function toggleEditTieBreak(pid) {
    const scores = readEditScoresLive();
    const ties = (typeof detectScoreTies === 'function') ? detectScoreTies(Object.keys(scores), scores) : [];
    let group = [];
    for (const g of ties) { if (g.indexOf(pid) !== -1) { group = g; break; } }
    const wasOn = !!_editTieBreaks[pid];
    group.forEach(p => { delete _editTieBreaks[p]; });
    if (!wasOn) _editTieBreaks[pid] = true;
    renderEditTieBreakBar();
}
window.renderEditTieBreakBar = renderEditTieBreakBar;
window.toggleEditTieBreak = toggleEditTieBreak;

function editSession(sessionId) {
    if (typeof can !== 'function' || !can('match.edit')) {
        showNotification(t('rbac.noPermission'), 'error');
        return;
    }

    const session = state.games.find(g => String(g.id) === String(sessionId));
    if (!session) {
        showNotification(t('m3.sessionNotFound'), 'error');
        return;
    }

    const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');
    const participants = session.participants && session.participants.length
        ? session.participants
        : Object.keys(session.scores || {});

    const catalogOptions = Object.keys(state.catalog).map(g =>
        `<option value="${esc(g)}" ${g === session.gameName ? 'selected' : ''}>${esc(g)}</option>`).join('');

    const date = new Date(session.timestamp);
    const dateVal = isNaN(date) ? '' : date.toISOString().split('T')[0];

    const scoreRows = participants.map(p => {
        const safe = p.replace(/[^a-zA-Z0-9]/g, '_');
        const cur = (session.scores && session.scores[p] != null) ? session.scores[p] : 0;
        const pName = (typeof displayNameById === 'function' && displayNameById(p)) || p;
        return `
            <div style="display:flex; align-items:center; gap:10px; margin-bottom:8px;">
                <span style="flex:1;">${esc(pName)}</span>
                <input type="number" step="0.5" id="edit-score-${safe}" data-player="${esc(p)}"
                       class="form-control" style="max-width:120px;" value="${cur}" oninput="renderEditTieBreakBar()">
            </div>`;
    }).join('');

    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.dataset.sessionId = sessionId;
    const nm = id => (typeof displayNameById === 'function' && displayNameById(id)) || id;
    const isCoopS = session.type === 'coop' || !!session.coop;
    const isTournamentS = !!session.isTournament;
    const _coopS = session.coop || {};
    const _rolesList = (typeof rolesFor === 'function') ? rolesFor(session.gameName) : null;
    /* Tie-break: doar competitiv uniformizat (nu coop/friendly/campanie). Stare proprie de editare. */
    const showTieBreakS = (session.scoreMode === 'uniform') && !isCoopS && !session.friendly && session.scoreKind !== 'campaign';
    _editTieBreaks = Object.assign({}, session.tieBreaks || {});

    /* Roluri per participant (coop + normal), pre-completate. */
    const roleRows = (_rolesList && _rolesList.length) ? participants.map(p => {
        const safe = p.replace(/[^a-zA-Z0-9]/g, '_');
        const cur = (session.roles && session.roles[p]) || '';
        return `<div style="display:flex; align-items:center; gap:10px; margin-bottom:8px;">
                <span style="flex:1;">${esc(nm(p))}</span>
                <select id="edit-role-${safe}" data-player="${esc(p)}" class="form-control" style="max-width:180px;">
                    <option value="">${t('session.role')}</option>
                    ${_rolesList.map(r => `<option value="${esc(r)}" ${cur === r ? 'selected' : ''}>${esc(r)}</option>`).join('')}
                </select>
            </div>`;
    }).join('') : '';

    /* Bloc turneu (metadate), pre-completat. */
    const tournamentBlock = isTournamentS ? `
                <h3 class="card-title"><i class="fas fa-trophy"></i> ${t('session.tournament')}</h3>
                <div class="form-row">
                    <div class="form-group"><label for="editTournamentName">${t('session.tName')}</label><input type="text" id="editTournamentName" class="form-control" value="${esc(session.tournamentName || '')}"></div>
                    <div class="form-group"><label for="editTournamentFormat">${t('session.format')}</label><input type="text" id="editTournamentFormat" class="form-control" value="${esc(session.format || '')}"></div>
                </div>
                <div class="form-row">
                    <div class="form-group"><label for="editTournamentPrize">${t('session.prize')}</label><input type="text" id="editTournamentPrize" class="form-control" value="${esc(session.prize || '')}"></div>
                    <div class="form-group"><label for="editTournamentRounds">${t('session.rounds')}</label><input type="number" id="editTournamentRounds" class="form-control" value="${session.rounds || ''}"></div>
                    <div class="form-group"><label for="editTournamentFee">${t('session.fee')}</label><input type="text" id="editTournamentFee" class="form-control" value="${esc(session.fee || '')}"></div>
                </div>` : '';

    /* Bloc coop (rezultat de echipă + metadate), pre-completat. */
    const _DIFFS = ['', 'easy', 'normal', 'hard', 'heroic', 'brutal', 'custom'];
    const _diffOpts = _DIFFS.map(d => `<option value="${d}" ${(_coopS.difficulty || '') === d ? 'selected' : ''}>${d === '' ? t('coop.diff.none') : t('coop.diff.' + d)}</option>`).join('');
    const _mvpIsCustom = !!_coopS.mvpCustom;
    const _mvpOpts = ['<option value="" ' + (!_coopS.mvp && !_mvpIsCustom ? 'selected' : '') + '>' + t('coop.mvpNone') + '</option>']
        .concat(participants.map(p => '<option value="' + esc(p) + '" ' + (_coopS.mvp === p ? 'selected' : '') + '>' + esc(nm(p)) + '</option>'))
        .concat(['<option value="__custom__" ' + (_mvpIsCustom ? 'selected' : '') + '>' + t('coop.mvpCustom') + '</option>']).join('');
    const coopBlock = isCoopS ? `
                <h3 class="card-title"><i class="fas fa-handshake"></i> ${t('hist.coop')}</h3>
                <div class="form-row">
                    <div class="form-group"><label for="editCoopOutcome">${t('session.coopResult')}</label>
                        <select id="editCoopOutcome" class="form-control">
                            <option value="win" ${_coopS.outcome === 'win' ? 'selected' : ''}>${t('session.coopWin')}</option>
                            <option value="loss" ${_coopS.outcome === 'loss' ? 'selected' : ''}>${t('session.coopLoss')}</option>
                        </select>
                    </div>
                    <div class="form-group"><label for="editCoopScore">${t('session.teamScore')}</label><input type="number" id="editCoopScore" class="form-control" value="${_coopS.teamScore != null ? _coopS.teamScore : ''}"></div>
                </div>
                <div class="form-row">
                    <div class="form-group"><label for="editCoopDifficulty">${t('coop.difficulty')}</label>
                        <select id="editCoopDifficulty" class="form-control" onchange="document.getElementById('editCoopDiffCustomWrap').classList.toggle('hidden', this.value!=='custom')">${_diffOpts}</select>
                    </div>
                    <div class="form-group ${_coopS.difficulty === 'custom' ? '' : 'hidden'}" id="editCoopDiffCustomWrap"><label for="editCoopDiffLabel">${t('coop.difficultyCustom')}</label><input type="text" id="editCoopDiffLabel" class="form-control" value="${esc(_coopS.difficultyLabel || '')}"></div>
                </div>
                <div class="form-group"><label for="editCoopDetail">${t('coop.detail')}</label><input type="text" id="editCoopDetail" class="form-control" value="${esc(_coopS.detail || '')}"></div>
                <div class="form-group"><label for="editCoopScenario">${t('session.scenario')}</label><input type="text" id="editCoopScenario" class="form-control" value="${esc(_coopS.scenario || '')}"></div>
                <div class="form-group"><label for="editCoopMvp">${t('coop.mvp')}</label>
                    <select id="editCoopMvp" class="form-control" onchange="document.getElementById('editCoopMvpCustomWrap').classList.toggle('hidden', this.value!=='__custom__')">${_mvpOpts}</select>
                    <div id="editCoopMvpCustomWrap" class="${_mvpIsCustom ? '' : 'hidden'}" style="margin-top:6px;"><input type="text" id="editCoopMvpCustom" class="form-control" value="${esc(_coopS.mvpCustom || '')}" placeholder="${t('coop.mvpCustomPh')}"></div>
                </div>` : '';

    modal.innerHTML = `
        <div class="modal-content" style="max-width:640px; max-height:90vh;">
            <div class="modal-header">
                <h2><i class="fas fa-edit"></i> ${t('history.editSessionTitle')}</h2>
                <button class="modal-close" onclick="this.closest('.modal').remove()">×</button>
            </div>
            <div style="max-height:65vh; overflow-y:auto; padding-right:6px;">
                <div class="form-row">
                    <div class="form-group">
                        <label for="editSessionGame"><i class="fas fa-dice"></i> ${t('session.game')}</label>
                        <select id="editSessionGame" class="form-control">${catalogOptions || `<option>${esc(session.gameName)}</option>`}</select>
                    </div>
                    <div class="form-group">
                        <label for="editSessionDate"><i class="fas fa-calendar"></i> ${t('session.date')}</label>
                        <input type="date" id="editSessionDate" class="form-control" value="${dateVal}">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="editSessionLocation"><i class="fas fa-map-marker-alt"></i> ${t('event.location')}</label>
                        <input type="text" id="editSessionLocation" class="form-control" value="${esc(session.location || '')}">
                    </div>
                    <div class="form-group">
                        <label for="editSessionDuration"><i class="fas fa-hourglass"></i> ${t('hist.durationMin')}</label>
                        <input type="number" id="editSessionDuration" class="form-control" value="${session.duration || ''}">
                    </div>
                </div>
                <div class="form-group">
                    <label for="editSessionNotes"><i class="fas fa-sticky-note"></i> ${t('common.notes')}</label>
                    <textarea id="editSessionNotes" class="form-control" rows="2">${esc(session.notes || '')}</textarea>
                </div>
                ${tournamentBlock}
                ${isCoopS ? coopBlock : `
                <h3 class="card-title"><i class="fas fa-trophy"></i> ${t('stats.scoresH')}</h3>
                ${scoreRows || '<p class="text-muted">' + t('hist.noScored') + '</p>'}
                ${showTieBreakS ? '<div id="editTieBreakBar"></div>' : ''}`}
                ${roleRows ? `<h3 class="card-title"><i class="fas fa-masks-theater"></i> ${t('roles.heading')}</h3>${roleRows}` : ''}
            </div>
            <div class="btn-group mt-20">
                <button class="btn btn-success" onclick="saveEditedSession()">
                    <i class="fas fa-save"></i> ${t('common.saveChanges')}
                </button>
                <button class="btn btn-secondary" onclick="this.closest('.modal').remove()">
                    <i class="fas fa-times"></i> ${t('common.cancel')}
                </button>
            </div>
        </div>`;
    document.body.appendChild(modal);
    if (showTieBreakS && typeof renderEditTieBreakBar === 'function') renderEditTieBreakBar();
}

/* Contribuția la clasament per jucător dintr-o sesiune (oglindă a _session_points_map
   din DB): friendly=>0; uniform=>clubPoints[pid] (dacă !=0); raw=>scores[pid] (dacă >0).
   Folosit DOAR pe calea demo, ca delta locală să fie corectă (inclusiv la uniform). */
function _sessionContribution(scores, clubPoints, isUniform, isFriendly) {
    const out = {};
    if (isFriendly) return out;
    Object.keys(scores || {}).forEach(pid => {
        let v;
        if (isUniform) { v = Number(clubPoints && clubPoints[pid]) || 0; if (v === 0) return; }
        else { v = Number(scores[pid]) || 0; if (!(v > 0)) return; }
        out[pid] = v;
    });
    return out;
}

/* Aplică pe obiectul sesiune câmpurile editate (DOAR după ce persistarea a reușit). */
function _assignEditedSession(session, v) {
    session.gameName = v.newGame;
    session.location = v.newLocation;
    session.duration = v.newDuration;
    session.notes = v.newNotes;
    session.timestamp = v.newTs;
    session.scores = v.newScores;
    session.winners = v.newWinners;
    session.clubPoints = v.newClubPoints;
    if (v.newCoop !== undefined) session.coop = v.newCoop;
    if (v.newRoles !== undefined) session.roles = v.newRoles;
    if (v.newTieBreaks !== undefined) session.tieBreaks = v.newTieBreaks;
    if (v.tourMeta) {
        session.tournamentName = v.tourMeta.tournamentName;
        session.format = v.tourMeta.format;
        session.prize = v.tourMeta.prize;
        session.rounds = v.tourMeta.rounds;
        session.fee = v.tourMeta.fee;
    }
}

async function saveEditedSession() {
    if (typeof requireWritableClub === 'function' && !requireWritableClub()) return;
    if (typeof can !== 'function' || !can('match.edit')) { showNotification(t('rbac.noPermission'), 'error'); return; }
    const modal = document.querySelector('.modal.active');
    if (!modal) return;
    const sessionId = modal.dataset.sessionId;
    const session = state.games.find(g => String(g.id) === String(sessionId));
    if (!session) { showNotification(t('m3.sessionGone'), 'error'); return; }

    /* --- Citește noile valori în locale; NU mutăm sesiunea încă --- */
    const newGame = document.getElementById('editSessionGame').value || session.gameName;
    const newLocation = document.getElementById('editSessionLocation').value.trim() || null;
    const _dur = parseInt(document.getElementById('editSessionDuration').value);
    const newDuration = isNaN(_dur) ? null : _dur;
    const newNotes = document.getElementById('editSessionNotes').value.trim() || null;
    const newDateStr = document.getElementById('editSessionDate').value;
    let newTs = session.timestamp;
    if (newDateStr) {
        const old = new Date(session.timestamp);
        const tt = isNaN(old) ? new Date() : old;
        const d = new Date(newDateStr);
        d.setHours(tt.getHours(), tt.getMinutes(), 0, 0);
        newTs = d.toISOString();
    }

    const _participants = (session.participants && session.participants.length) ? session.participants : Object.keys(session.scores || {});
    const _gv = id => { const el = document.getElementById(id); return el ? el.value : ''; };
    const isUniform = session.scoreMode === 'uniform';
    const isCoopEdit = session.type === 'coop' || !!session.coop;

    /* Roluri editate (coop + normal). */
    const newRoles = {};
    modal.querySelectorAll('select[id^="edit-role-"]').forEach(sel => {
        const p = sel.dataset.player;
        if (p && sel.value) newRoles[p] = sel.value;
    });

    /* Metadate turneu editate. */
    let tourMeta = null;
    if (session.isTournament) {
        const _r = parseInt(_gv('editTournamentRounds'));
        tourMeta = {
            tournamentName: (_gv('editTournamentName') || '').trim(),
            format: (_gv('editTournamentFormat') || '').trim(),
            prize: (_gv('editTournamentPrize') || '').trim(),
            rounds: isNaN(_r) ? null : _r,
            fee: (_gv('editTournamentFee') || '').trim()
        };
    }

    let newScores, newWinners, newClubPoints, newCoop = session.coop || null, newTieBreaks = session.tieBreaks || null;

    if (isCoopEdit) {
        /* Co-op: rezultat de echipă + metadate. Recalcul coerent cu salvarea (Faza 1-4). */
        const outcome = _gv('editCoopOutcome') || 'win';
        const tsRaw = _gv('editCoopScore');
        const teamScoreNum = (tsRaw === '' || tsRaw == null) ? null : Number(tsRaw);
        const difficulty = _gv('editCoopDifficulty') || '';
        const difficultyLabel = (_gv('editCoopDiffLabel') || '').trim();
        const detail = (_gv('editCoopDetail') || '').trim();
        const scenario = (_gv('editCoopScenario') || '').trim();
        const mvpSel = _gv('editCoopMvp') || '';
        let mvp = null, mvpCustom = null;
        if (mvpSel === '__custom__') mvpCustom = (_gv('editCoopMvpCustom') || '').trim() || null;
        else if (mvpSel && _participants.indexOf(mvpSel) !== -1) mvp = mvpSel;
        newCoop = {
            outcome,
            teamScore: (teamScoreNum == null || isNaN(teamScoreNum)) ? null : teamScoreNum,
            scenario: scenario || null,
            difficulty: difficulty || null,
            difficultyLabel: (difficulty === 'custom') ? (difficultyLabel || null) : null,
            detail: detail || null,
            mvp, mvpCustom
        };
        /* Scoruri: pe raw, scorul de echipă se adaugă egal DOAR la victorie; altfel 0. */
        const _teamToPoints = (session.scoreMode === 'raw' && outcome === 'win' && teamScoreNum != null && !isNaN(teamScoreNum) && teamScoreNum > 0);
        newScores = {};
        _participants.forEach(p => { newScores[p] = _teamToPoints ? teamScoreNum : 0; });
        newWinners = outcome === 'win' ? _participants.slice() : [];
        if (isUniform && typeof computeClubPoints === 'function') {
            const conv = computeClubPoints(_participants, newScores, 'coop', getScoringTemplates(), { coopWin: outcome === 'win' });
            newClubPoints = conv.points;
            newWinners = conv.winners;
        } else {
            newClubPoints = null;
        }
    } else {
        /* Non-coop: scoruri individuale (comportament existent). */
        newScores = Object.assign({}, session.scores || {});
        modal.querySelectorAll('input[id^="edit-score-"]').forEach(input => {
            const player = input.dataset.player;
            if (player) newScores[player] = parseFloat(input.value) || 0;
        });
        newWinners = Array.isArray(session.winners) ? session.winners.slice() : [];
        newClubPoints = session.clubPoints || null;
        /* Direcția scorului la editare: cea persistată a sesiunii; dacă lipsește,
           moștenită de la jocul (nou) selectat; altfel 'high'. */
        let _editDir = (session.scoreDir === 'low') ? 'low' : (session.scoreDir === 'high' ? 'high' : null);
        if (!_editDir) { const _g = (state.catalog || {})[newGame]; _editDir = (_g && _g.scoreDir === 'low') ? 'low' : 'high'; }
        if (session.friendly) {
            newWinners = [];
        } else if (isUniform && typeof computeClubPoints === 'function') {
            const _kind = session.scoreKind || 'competitive';
            newTieBreaks = _editTieBreaks || {};
            const conv = computeClubPoints(session.participants, newScores, _kind, getScoringTemplates(), {
                coopWin: false, tieBreaks: newTieBreaks, scoreDir: _editDir, bonuses: newScores
            });
            newClubPoints = conv.points;
            newWinners = conv.winners;
        } else {
            const vals = Object.values(newScores);
            if (_editDir === 'low') {
                const minScore = vals.length ? Math.min(...vals) : 0;
                newWinners = vals.length ? Object.entries(newScores).filter(([, s]) => s === minScore).map(([n]) => n) : [];
            } else {
                const maxScore = vals.length ? Math.max(...vals) : 0;
                newWinners = maxScore > 0 ? Object.entries(newScores).filter(([, s]) => s === maxScore).map(([n]) => n) : [];
            }
        }
        session.scoreDir = _editDir; /* propagă în draft -> meta (via _buildSessionMeta) */
    }

    const draft = Object.assign({}, session, {
        gameName: newGame, location: newLocation, duration: newDuration, notes: newNotes,
        timestamp: newTs, scores: newScores, winners: newWinners, clubPoints: newClubPoints,
        coop: newCoop, roles: newRoles, tieBreaks: newTieBreaks
    });
    if (tourMeta) Object.assign(draft, tourMeta);
    const newMeta = (typeof _buildSessionMeta === 'function') ? _buildSessionMeta(draft) : undefined;
    const _v = { newGame, newLocation, newDuration, newNotes, newTs, newScores, newWinners, newClubPoints, newCoop, newRoles, tourMeta, newTieBreaks };

    const _isDemo = (typeof isDemoMode === 'function') && isDemoMode();
    const _isTmp = !session.id || String(session.id).startsWith('tmp-');

    /* --- Persistă ATOMIC; mută local DOAR după succes (riscul H) --- */
    if (!_isDemo && !_isTmp) {
        const res = await sb.rpc('edit_session_atomic', {
            p_club_id: currentClubId, p_match_id: session.id,
            p_payload: { game_title: newGame, date: newTs, scores: newScores, winners: newWinners, club_points: newClubPoints, meta: newMeta }
        });
        if (res.error) {
            logError('saveEditedSession.rpc', res.error);
            showNotification(t('sb.errorColon') + res.error.message, 'error');
            return;  /* nimic mutat local -> fără desincronizare scoruri↔puncte */
        }
        _assignEditedSession(session, _v);
        /* Aplică delta de puncte întoarsă de RPC (sursa de adevăr, per-club). */
        const delta = (res.data && res.data.applied_delta) || {};
        Object.keys(delta).forEach(pid => {
            const m = (typeof memberById === 'function') ? memberById(pid) : (state.membersById && state.membersById[pid]);
            if (m) m.score = (m.score || 0) + Number(delta[pid]);
        });
    } else {
        /* Demo / sesiune locală: calculează delta local (corect și la uniform). */
        const oldC = _sessionContribution(session.scores, session.clubPoints, isUniform, session.friendly);
        const newC = _sessionContribution(newScores, newClubPoints, isUniform, session.friendly);
        _assignEditedSession(session, _v);
        const keys = new Set(Object.keys(oldC).concat(Object.keys(newC)));
        keys.forEach(pid => {
            const d = (Number(newC[pid]) || 0) - (Number(oldC[pid]) || 0);
            if (d) { const m = (typeof memberById === 'function') ? memberById(pid) : (state.membersById && state.membersById[pid]); if (m) m.score = (m.score || 0) + d; }
        });
    }

    /* Optimist↔hidratat: ține currentUser.points aliniat (per-club). */
    if (state.currentUser && state.currentUser.id) {
        const cm = (typeof memberById === 'function') ? memberById(state.currentUser.id) : (state.membersById && state.membersById[state.currentUser.id]);
        if (cm) state.currentUser.points = cm.score;
    }

    saveState();
    if (typeof renderHistory === 'function') renderHistory();
    if (typeof renderDashboard === 'function') renderDashboard();
    if (typeof renderPlayers === 'function') renderPlayers();
    addAuditLog('audit.sessionEdited', state.currentUser.name, `${session.gameName} (${sessionId})`);
    modal.remove();
    showNotification(t('m3.sessionUpdated'), 'success');
}

async function deleteSession(sessionId) {
    if (!isAdmin) {
        showNotification(t('m3.onlyAdminDeleteSessions'), 'error');
        return;
    }
    
    if (!await confirmModal(t('m3.confirmDeleteSession'), { danger: true })) {
        return;
    }
    
    const sessionIndex = state.games.findIndex(g => g.id === sessionId);
    if (sessionIndex === -1) return;
    
    const session = state.games[sessionIndex];
    
    // Remove session from games
    state.games.splice(sessionIndex, 1);
    
    // Update player stats (reverse the points) — identitate = id
    if (session.scores) {
        Object.entries(session.scores).forEach(([player, score]) => {
            const mem = (typeof memberById === 'function') ? memberById(player) : (state.membersById && state.membersById[player]);
            if (mem) {
                mem.score -= score;
                mem.gamesPlayed = Math.max(0, (mem.gamesPlayed || 0) - 1);
            }
        });
    }
    
    // Update game catalog stats
    if (session.gameName && state.catalog[session.gameName]) {
        const game = state.catalog[session.gameName];
        game.timesPlayed = Math.max(0, (game.timesPlayed || 0) - 1);
    }
    
    // Save and update
    saveState();
    renderHistory();
    renderDashboard();
    renderPlayers();
    renderCatalog();
    
    addAuditLog('audit.sessionDeleted', state.currentUser.name, 
        `${session.gameName} - ${new Date(session.timestamp).toLocaleDateString('en-GB')}`);
    
    showNotification(t('m3.sessionDeleted'), 'success');
}

/* ================= UTILITY FUNCTIONS ================= */
function saveState() {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
        console.error('Error saving state:', error);
        showNotification(t('m3.saveDataError'), 'error');
    }
}

function initTooltips() {
    // Create tooltip container
    const tooltip = document.createElement('div');
    tooltip.id = 'global-tooltip';
    tooltip.style.cssText = `
        position: absolute;
        background: var(--bg-card);
        color: var(--text-primary);
        padding: 8px 12px;
        border-radius: 8px;
        font-size: 0.85em;
        max-width: 300px;
        border: 2px solid var(--border);
        box-shadow: 0 5px 15px rgba(0,0,0,0.3);
        z-index: 99999;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.2s ease;
        backdrop-filter: blur(10px);
    `;
    document.body.appendChild(tooltip);
    
    // Add tooltip attributes to elements
    document.querySelectorAll('[data-tooltip]').forEach(element => {
        element.addEventListener('mouseenter', function(e) {
            const text = this.getAttribute('data-tooltip');
            if (!text) return;
            
            tooltip.textContent = text;
            tooltip.style.opacity = '1';
            
            const rect = this.getBoundingClientRect();
            tooltip.style.left = (rect.left + (rect.width / 2)) + 'px';
            tooltip.style.top = (rect.top - 40) + 'px';
            tooltip.style.transform = 'translateX(-50%)';
        });
        
        element.addEventListener('mouseleave', function() {
            tooltip.style.opacity = '0';
        });
        
        element.addEventListener('mousemove', function(e) {
            tooltip.style.left = (e.clientX + 15) + 'px';
            tooltip.style.top = (e.clientY + 15) + 'px';
            tooltip.style.transform = 'none';
        });
    });
    
    // Add tooltips to common elements
    addDynamicTooltips();
}

function addDynamicTooltips() {
    // Add tooltips to buttons
    document.addEventListener('mouseover', function(e) {
        const target = e.target;
        
        // Check for button tooltips
        if (target.tagName === 'BUTTON') {
            const text = target.textContent.trim();
            const icon = target.querySelector('i')?.className || '';
            
            if (text && text.length < 20) {
                let tooltipText = '';
                
                // Set tooltip based on button content
                if (icon.includes('fa-save')) tooltipText = t('common.saveChanges');
                else if (icon.includes('fa-trash')) tooltipText = t('common.delete');
                else if (icon.includes('fa-edit')) tooltipText = t('tip.edit');
                else if (icon.includes('fa-plus')) tooltipText = t('session.add');
                else if (icon.includes('fa-search')) tooltipText = t('tip.search');
                else if (icon.includes('fa-filter')) tooltipText = t('tip.filter');
                else if (icon.includes('fa-download')) tooltipText = t('tip.download');
                else if (icon.includes('fa-upload')) tooltipText = t('tip.upload');
                else if (icon.includes('fa-print')) tooltipText = t('tip.print');
                else if (icon.includes('fa-chart')) tooltipText = t('tip.stats');
                else if (icon.includes('fa-users')) tooltipText = t('stats.players');
                else if (icon.includes('fa-gamepad')) tooltipText = t('tip.games');
                else if (icon.includes('fa-history')) tooltipText = t('tip.history');
                else if (icon.includes('fa-comments')) tooltipText = 'Chat';
                else if (icon.includes('fa-calendar')) tooltipText = 'Calendar';
                else if (icon.includes('fa-poll')) tooltipText = t('tip.polls');
                else if (icon.includes('fa-dice')) tooltipText = 'Randomizers';
                else if (icon.includes('fa-cogs')) tooltipText = t('tip.settings');
                else if (icon.includes('fa-sign-out')) tooltipText = t('tip.logout');
                else if (icon.includes('fa-user')) tooltipText = t('tip.profile');
                else if (icon.includes('fa-star')) tooltipText = 'Rating';
                else if (icon.includes('fa-trophy')) tooltipText = t('session.tournament');
                else if (icon.includes('fa-crown')) tooltipText = t('csv.winner');
                else if (icon.includes('fa-clock')) tooltipText = t('tip.time');
                else if (icon.includes('fa-map-marker')) tooltipText = t('event.location');
                
                if (tooltipText) {
                    target.setAttribute('data-tooltip', tooltipText);
                }
            }
        }
        
        // Add tooltips to form controls
        if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA') {
            const placeholder = target.getAttribute('placeholder') || '';
            const label = target.previousElementSibling?.textContent || '';
            
            if (placeholder && !target.hasAttribute('data-tooltip')) {
                target.setAttribute('data-tooltip', placeholder);
            } else if (label && !target.hasAttribute('data-tooltip')) {
                target.setAttribute('data-tooltip', label.trim());
            }
        }
        
        // Add tooltips to table headers
        if (target.tagName === 'TH') {
            const text = target.textContent.trim();
            if (text && !target.hasAttribute('data-tooltip')) {
                let tooltipText = '';
                
                switch(text.toLowerCase()) {
                    case 'loc': tooltipText = t('tip.rankPos'); break;
                    case 'jucător': tooltipText = t('tip.playerName'); break;
                    case 'puncte': tooltipText = t('tip.pointsAccrued'); break;
                    case 'scoruri': tooltipText = t('tip.scoresSum'); break;
                    case 'jocuri': tooltipText = t('tip.gamesCount'); break;
                    case 'medie': tooltipText = t('tip.avgPerGame'); break;
                    case 'win rate': tooltipText = t('tip.winPct'); break;
                    case 'trend': tooltipText = t('tip.recentTrend'); break;
                    case 'data': tooltipText = t('tip.sessionDate'); break;
                    case 'ora': tooltipText = t('tip.startTime'); break;
                    case 'dificultate': tooltipText = t('tip.complexity'); break;
                    case 'rating': tooltipText = t('tip.gameRating'); break;
                    case 'participanți': tooltipText = t('tip.presentPlayers'); break;
                    case 'durată': tooltipText = t('tip.playTime'); break;
                    case 'scor': tooltipText = t('tip.scoreObtained'); break;
                    /* Echivalentele EN — înainte tooltip-urile de tabel apăreau doar cu interfața în română. */
                    case 'rank': tooltipText = t('tip.rankPos'); break;
                    case 'player': tooltipText = t('tip.playerName'); break;
                    case 'points': tooltipText = t('tip.pointsAccrued'); break;
                    case 'scores': tooltipText = t('tip.scoresSum'); break;
                    case 'games': tooltipText = t('tip.gamesCount'); break;
                    case 'average': tooltipText = t('tip.avgPerGame'); break;
                    case 'date': tooltipText = t('tip.sessionDate'); break;
                    case 'time': tooltipText = t('tip.startTime'); break;
                    case 'difficulty': tooltipText = t('tip.complexity'); break;
                    case 'participants': tooltipText = t('tip.presentPlayers'); break;
                    case 'duration': tooltipText = t('tip.playTime'); break;
                    case 'score': tooltipText = t('tip.scoreObtained'); break;
                }
                
                if (tooltipText) {
                    target.setAttribute('data-tooltip', tooltipText);
                }
            }
        }
    }, true);
}

function startPeriodicUpdates() {
    if (window._periodicStarted) return;
    window._periodicStarted = true;
    // Update online status every 2 minutes
    setInterval(() => {
        if (state.currentUser) {
            updateOnlineStatus(true);
        }
    }, 120000);
    
    // Update notifications every 30 seconds
    setInterval(() => {
        checkAndShowNotifications();
    }, 30000);

    // Reîmprospătează notificările din TOATE cluburile (live-ish) la 45s
    setInterval(() => {
        if (state.currentUser && !isDemoMode()) {
            try { loadAllNotifications().then(function () { renderNotifBadge(); }); } catch (e) { logError('startPeriodicUpdates', e); }
        }
    }, 45000);
    
    // Auto-save state every 5 minutes (centură de siguranță; saveState e apelat
    // deja explicit după fiecare mutație reală). NU se auditează: e o acțiune de
    // sistem, nu una a utilizatorului — o intrare la 5 min ar polua jurnalul
    // (local + DB prin RPC) și ar atribui fals acțiunea userului logat.
    setInterval(() => {
        if (state.currentUser && !state.currentUser.isDemo) {
            saveState();
        }
    }, 300000);
    
    // Check for expired events and polls every minute
    setInterval(() => {
        checkExpiredPolls();
        checkUpcomingEvents();
    }, 60000);
}

function checkAndShowNotifications() {
    if (!state.currentUser) return;
    
    const userEmail = state.currentUser.email;
    if (!state.notifications[userEmail]) return;
    
    // Get unread notifications
    const unreadNotifications = state.notifications[userEmail].filter(n => !n.read);
    
    if (unreadNotifications.length > 0) {
        // Show the most recent notification
        const latestNotification = unreadNotifications[unreadNotifications.length - 1];

        showNotification(latestNotification.message, 'info');
        
        // Mark as read
        const notificationIndex = state.notifications[userEmail].findIndex(n => 
            n.id === latestNotification.id
        );
        
        if (notificationIndex !== -1) {
            state.notifications[userEmail][notificationIndex].read = true;
            saveState();
        }
    }
}

function checkUpcomingEvents() {
    const now = new Date();
    const oneHourFromNow = new Date(now.getTime() + 60 * 60 * 1000);
    
    const upcomingEvents = state.events.filter(event => {
        const eventDate = new Date(event.date);
        return eventDate > now && eventDate <= oneHourFromNow;
    });
    
    upcomingEvents.forEach(event => {
        // Check if user is participating
        const isParticipant = rsvpOf(event.participants, state.currentUser?.id) === 'yes';
        
        if (isParticipant) {
            // Show notification for participants
            const timeUntilEvent = Math.round((new Date(event.date) - now) / 60000);
            
            if (timeUntilEvent <= 60 && timeUntilEvent > 0) {
                showNotification(
                    t('notif.eventStarting').replace('{title}', event.title).replace('{n}', timeUntilEvent).replace('{loc}', event.location ? t('notif.atLoc').replace('{l}', event.location) : ''),
                    'info'
                );
            }
        }
    });
}

